'use strict';

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));

var React = require('react');

var React__default = _interopDefault(React);

var styled = _interopDefault(require('styled-components'));

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));

var PropTypes = _interopDefault(require('prop-types'));

var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));

var color = _interopDefault(require('color'));

var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));

var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));

var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));

var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));

var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));

var _assertThisInitialized = _interopDefault(require('@babel/runtime/helpers/assertThisInitialized'));

var classNames = _interopDefault(require('classnames'));

var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));

var _require = require('styled-components'),
    css = _require.css,
    withTheme = _require.withTheme,
    ThemeContext = _require.ThemeContext;

var classNameFromString = function classNameFromString(name) {
  return encodeURIComponent(name.toLowerCase()).replace(/%[0-9A-F]{2}/gi, '');
};

function SvgIcon(props) {
  var children = props.children,
      Component = props.component,
      title = props.title,
      viewBox = props.viewBox,
      other = _objectWithoutProperties(props, ["children", "component", "title", "viewBox"]);

  var ariaLabelledby = title ? "".concat(randomString(), "-").concat(classNameFromString(title)) : null;
  return React__default.createElement(Component, _extends({
    focusable: "false",
    viewBox: viewBox,
    "aria-hidden": title ? 'false' : 'true',
    role: title ? 'img' : 'presentation',
    "aria-labelledby": ariaLabelledby
  }, other), children, title ? React__default.createElement("title", {
    id: ariaLabelledby
  }, title) : null);
}

SvgIcon.propTypes = {
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node.isRequired,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
};
SvgIcon.defaultProps = {
  component: 'svg',
  viewBox: '0 0 24 24'
};
SvgIcon.craneName = 'SvgIcon';

var createSvgIcon = function createSvgIcon(path, displayName, viewBox) {
  var Icon = function Icon(props) {
    return React__default.createElement(SvgIcon, _extends({}, props, {
      viewBox: viewBox || null
    }), path);
  };

  Icon.displayName = "".concat(displayName, "Icon");
  return Icon;
};

function insertLink(obj, link) {
  return _typeof(obj) !== 'object' ? obj : Object.keys(obj).map(function (key) {
    return key === 'link' ? React__default.createElement("a", {
      key: key,
      href: link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, obj[key]) : obj[key];
  });
}

var getIntentColor = function getIntentColor(_ref) {
  var intent = _ref.intent,
      theme = _ref.theme,
      _ref$defaultColor = _ref.defaultColor,
      defaultColor = _ref$defaultColor === void 0 ? '#dddddd' : _ref$defaultColor;

  switch (intent) {
    case 'success':
      return theme.successColor;

    case 'warning':
      return theme.warningColor;

    case 'danger':
      return theme.dangerColor;

    case 'secondary':
      return theme.secondaryColor;

    case 'primary':
      return theme.primaryColor;

    default:
      return defaultColor;
  }
};

var getContrastColor = function getContrastColor(_ref) {
  var backgroundColor = _ref.backgroundColor,
      colors = _ref.colors,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 50 : _ref$threshold;
  var lightness = color(backgroundColor).hsl().color[2];
  var contrastColor = lightness < threshold ? colors.dark : colors.light;
  return contrastColor;
};

var randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return Math.random().toString(length).replace(/[^a-zA-Z0-9]+/g, '').substr(0, 5);
};

var separateUnit = function separateUnit(str) {
  var val = /([0-9])*/.exec(str)[0];
  var unit = str.substr(val.length, str.length - 1);
  return [val, unit];
};

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n    background-image: none;\n    font-size: 1rem;\n    padding: 16px 40px;\n    border: 0;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.15s ease-in-out;\n    font-family: ", ";\n    font-weight: bold;\n    border-radius: 4px;\n    text-transform: ", ";\n    &:hover,\n    &:active {\n      opacity: 0.8;\n      background-image: none;\n      text-decoration: none;\n    }\n    &:active {\n      transform: translateY(1px);\n    }\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", " !important;\n        color: ", ";\n        cursor: not-allowed !important;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        font-size: 14px;\n        padding: 10px 20px;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border: 2px solid ", ";\n    background-color: transparent;\n    color: ", ";\n    padding: 12px 36px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var outline = function outline(_ref) {
  var color = _ref.color;
  return css(_templateObject(), color, color);
};

var getType = function getType(_ref2) {
  var color = _ref2.color,
      type = _ref2.type;

  switch (type) {
    case 'outline':
      return outline({
        color: color
      });

    default:
      return '';
  }
};

var getSize = function getSize(_ref3) {
  var size = _ref3.size;

  switch (size) {
    case 'small':
      return css(_templateObject2());

    default:
      return '';
  }
};

var buttonStyles = function buttonStyles(_ref4) {
  var disabled = _ref4.disabled,
      intent = _ref4.intent,
      size = _ref4.size,
      theme = _ref4.theme,
      type = _ref4.type;
  var colors = {
    dark: theme.textColorDark,
    light: theme.textColor
  };
  var color = getIntentColor({
    intent: intent,
    theme: theme,
    defaultColor: '#dddddd'
  });
  var typeCSS = getType({
    color: color,
    type: type
  });
  var sizeCSS = getSize({
    size: size
  });
  var disabledCSS = !disabled ? null : css(_templateObject3(), theme.disabledColor || '#DDDDDD', getContrastColor({
    backgroundColor: theme.disabledColor || '#DDDDDD',
    colors: colors,
    threshold: theme.contrastLuminanceThreshold || 50
  }));
  return css(_templateObject4(), color, getContrastColor({
    backgroundColor: color,
    colors: colors
  }), theme.headerFontFamily, theme.uppercaseTitles ? 'uppercase' : 'none', typeCSS, sizeCSS, disabledCSS);
};

var _Button = styled.button(_templateObject5(), function (_ref5) {
  var disabled = _ref5.disabled,
      intent = _ref5.intent,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      theme = _ref5$theme === void 0 ? {} : _ref5$theme,
      type = _ref5.type;
  return buttonStyles({
    disabled: disabled,
    intent: intent,
    size: size,
    theme: theme,
    type: type
  });
});

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 4px;\n  &:last-child {\n    margin-right: 0;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.8em;\n  padding: 10px 15px;\n  border-radius: 0;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Button = styled(_Button)(_templateObject$1());
var ButtonGroup = styled.div(_templateObject2$1());

var getPageNumbers = function getPageNumbers(_ref) {
  var current = _ref.current,
      total = _ref.total,
      _ref$size = _ref.size,
      maxSize = _ref$size === void 0 ? 3 : _ref$size;
  var size = total < maxSize ? total : maxSize;
  var margin = Math.floor(size / 2);
  var shift = !(total <= maxSize);
  var first = shift && (total - current < margin ? total - margin * 2 : current > margin ? current - margin : 1) || 1;
  return new Array(size).fill(0).map(function (_, i) {
    return first + i;
  });
};

var PaginationControls = function PaginationControls(_ref2) {
  var currentPage = _ref2.currentPage,
      hasNextPage = _ref2.hasNextPage,
      hasPreviousPage = _ref2.hasPreviousPage,
      onPageChange = _ref2.onPageChange,
      _ref2$totalPages = _ref2.totalPages,
      totalPages = _ref2$totalPages === void 0 ? 0 : _ref2$totalPages,
      props = _objectWithoutProperties(_ref2, ["currentPage", "hasNextPage", "hasPreviousPage", "onPageChange", "totalPages"]);

  var nextPage = function nextPage() {
    if (totalPages && currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  var prevPage = function prevPage() {
    if (currentPage < 2) return;
    onPageChange(currentPage - 1);
  };

  var firstPage = function firstPage() {
    return onPageChange(1);
  };

  var lastPage = function lastPage() {
    return onPageChange(totalPages);
  };

  var goToPage = function goToPage(n) {
    return onPageChange(n);
  };

  return React__default.createElement("div", props, React__default.createElement(ButtonGroup, null, React__default.createElement(Button, {
    onClick: firstPage,
    disabled: !hasPreviousPage
  }, "<<"), React__default.createElement(Button, {
    intent: "primary",
    onClick: prevPage,
    disabled: !hasPreviousPage
  }, "<")), React__default.createElement(ButtonGroup, null, getPageNumbers({
    current: currentPage,
    total: totalPages
  }).map(function (n, i) {
    return React__default.createElement(Button, {
      key: "pagination-page-".concat(i),
      intent: n === currentPage ? 'primary' : null,
      onClick: function onClick() {
        if (n === currentPage) return;
        goToPage(n);
      }
    }, n);
  })), React__default.createElement(ButtonGroup, null, React__default.createElement(Button, {
    intent: "primary",
    onClick: nextPage,
    disabled: !hasNextPage
  }, ">"), React__default.createElement(Button, {
    onClick: lastPage,
    disabled: !hasNextPage
  }, ">>")));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  margin-top: 0;\n  background-color: ", ";\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  border-radius: 7.5px;\n  background-color: transparent;\n  border: 1px solid ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCounter = styled.div(_templateObject$2(), function (_ref) {
  var height = _ref.height;
  return "".concat(height, "px");
}, function (_ref2) {
  var intent = _ref2.intent,
      theme = _ref2.theme;
  return getIntentColor({
    intent: intent,
    theme: theme
  });
});
var StyledCounterInner = styled(StyledCounter)(_templateObject2$2(), function (props) {
  return "".concat(props.width || 0, "%");
}, function (_ref3) {
  var height = _ref3.height;
  return "".concat(height - 2, "px") || '12px';
}, function (_ref4) {
  var intent = _ref4.intent,
      theme = _ref4.theme;
  return getIntentColor({
    intent: intent,
    theme: theme
  });
});

function Counter(_ref5) {
  var current = _ref5.current,
      max = _ref5.max,
      _ref5$height = _ref5.height,
      height = _ref5$height === void 0 ? 12 : _ref5$height,
      intent = _ref5.intent,
      props = _objectWithoutProperties(_ref5, ["current", "max", "height", "intent"]);

  var width = current >= max ? 100 : 100 / max * current;
  return React__default.createElement(StyledCounter, _extends({
    intent: intent,
    height: height
  }, props), React__default.createElement(StyledCounterInner, {
    intent: intent,
    height: height,
    width: width
  }));
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    position: relative;\n    margin: 20px auto;\n    border: 3px solid #eee;\n    border-top: 3px solid ", ";\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    ", ";\n\n    @keyframes spin {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n  "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n        width: 60px;\n        height: 60px;\n      "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n        width: 120px;\n        height: 120px;\n      "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n        width: 30px;\n        height: 30px;\n      "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var getSize$1 = function getSize(_ref) {
  var size = _ref.size;

  switch (size) {
    case 'small':
      return css(_templateObject$3());

    case 'large':
      return css(_templateObject2$3());

    case 'medium':
    default:
      return css(_templateObject3$1());
  }
};

var loadingStyles = function loadingStyles(_ref2) {
  var intent = _ref2.intent,
      size = _ref2.size,
      theme = _ref2.theme;
  var color = getIntentColor({
    intent: intent,
    theme: theme
  });
  var sizeCSS = getSize$1({
    size: size
  });
  return css(_templateObject4$1(), color, sizeCSS);
};

var Loading = styled.div(_templateObject5$1(), function (_ref3) {
  var disabled = _ref3.disabled,
      intent = _ref3.intent,
      size = _ref3.size,
      _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? {} : _ref3$theme,
      type = _ref3.type;
  return loadingStyles({
    disabled: disabled,
    intent: intent,
    size: size,
    theme: theme,
    type: type
  });
});

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 6px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: calc(100% - 40px);\n  font-size: 15px;\n  line-height: 22px;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f1f1f1;\n  margin: 5px 10px 10px 0;\n  border: 0;\n  border-radius: 3px;\n  font-size: 18px;\n  display: inline-block;\n  width: auto;\n  height: auto;\n  vertical-align: top;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput = styled.input(_templateObject$4());
var Label = styled.label(_templateObject2$4());
var Title = styled.p(_templateObject3$2());

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    var _this;

    _classCallCheck(this, TextInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInput).call(this, props));
    _this.state = {
      _id: "".concat(randomString(), "-").concat(props.name)
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autocomplete = _this$props.autocomplete,
          labelText = _this$props.labelText,
          name = _this$props.name,
          titleText = _this$props.titleText,
          required = _this$props.required;
      var _id = this.state._id;
      var id = this.props.id || _id; // const Label = labelComp || StyledLabel;

      return React__default.createElement("div", {
        className: "crane-checkbox-input"
      }, titleText ? React__default.createElement(Title, {
        htmlFor: name
      }, titleText, required ? '*' : '') : null, React__default.createElement(StyledInput, _extends({
        type: "checkbox",
        name: name,
        id: id,
        autoComplete: autocomplete || name
      }, this.props)), labelText ? React__default.createElement(Label, {
        htmlFor: id
      }, labelText, required ? '*' : '') : null);
    }
  }]);

  return TextInput;
}(React.Component);

_defineProperty(TextInput, "propTypes", {
  name: PropTypes.string.isRequired
});

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 6px;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: calc(100% - 40px);\n  font-size: 15px;\n  line-height: 22px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f1f1f1;\n  margin: 5px 10px 10px 0;\n  border: 0;\n  border-radius: 3px;\n  font-size: 18px;\n  display: inline-block;\n  width: auto;\n  height: auto;\n  vertical-align: top;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput$1 = styled.input(_templateObject$5());
var Label$1 = styled.label(_templateObject2$5());
var Title$1 = styled.p(_templateObject3$3());

var RadioInput =
/*#__PURE__*/
function (_Component) {
  _inherits(RadioInput, _Component);

  function RadioInput(props) {
    var _this;

    _classCallCheck(this, RadioInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioInput).call(this, props));
    _this.state = {
      _id: "".concat(randomString(), "-").concat(props.name)
    };
    return _this;
  }

  _createClass(RadioInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          labelText = _this$props.labelText,
          name = _this$props.name,
          titleText = _this$props.titleText,
          value = _this$props.value,
          required = _this$props.required;
      var _id = this.state._id;
      var id = this.props.id || _id; // const Label = labelComp || StyledLabel;

      return React__default.createElement("div", {
        className: "crane-radio-input"
      }, titleText ? React__default.createElement(Title$1, {
        htmlFor: name
      }, titleText, required ? '*' : '') : null, React__default.createElement(StyledInput$1, _extends({
        type: "radio",
        name: name,
        id: id,
        value: value
      }, this.props)), labelText ? React__default.createElement(Label$1, {
        htmlFor: id
      }, labelText, required ? '*' : '') : null);
    }
  }]);

  return RadioInput;
}(React.Component);

_defineProperty(RadioInput, "propTypes", {
  name: PropTypes.string.isRequired
});

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 6px;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: calc(100% - 40px);\n  font-size: 18px;\n  line-height: 22px;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f1f1f1;\n  margin: 5px 10px 10px 0;\n  border: 0;\n  border-radius: 3px;\n  font-size: 18px;\n  display: inline-block;\n  width: 100%;\n  height: 50px;\n  vertical-align: top;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSelect = styled.select(_templateObject$6());
var Label$2 = styled.label(_templateObject2$6());
var Title$2 = styled.p(_templateObject3$4());

var TextInput$1 =
/*#__PURE__*/
function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    var _this;

    _classCallCheck(this, TextInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInput).call(this, props));
    _this.state = {
      _id: "".concat(randomString(), "-").concat(props.name)
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          labelText = _this$props.labelText,
          name = _this$props.name,
          titleText = _this$props.titleText,
          required = _this$props.required,
          options = _this$props.options;
      var _id = this.state._id;
      var id = this.props.id || _id; // const Label = labelComp || StyledLabel;

      return React__default.createElement("div", null, titleText ? React__default.createElement(Title$2, {
        htmlFor: name
      }, titleText, required ? '*' : '') : null, labelText ? React__default.createElement(Label$2, {
        htmlFor: id
      }, labelText, required ? '*' : '') : null, React__default.createElement(StyledSelect, _extends({
        type: "checkbox",
        name: name,
        id: id
      }, this.props), options ? options.map(function (o) {
        return React__default.createElement("option", {
          value: o
        }, o);
      }) : null));
    }
  }]);

  return TextInput;
}(React.Component);

_defineProperty(TextInput$1, "propTypes", {
  name: PropTypes.string.isRequired
});

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 600;\n  & + input {\n    margin-top: 6px;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f1f1f1;\n  width: 100%;\n  margin: 0 0 1rem 0;\n  border: 0;\n  height: 62px;\n  border-radius: 3px;\n  padding: 0 1rem;\n  font-size: 22px;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput$2 = styled.input(_templateObject$7());
var StyledLabel = styled.label(_templateObject2$7());

var TextInput$2 =
/*#__PURE__*/
function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    var _this;

    _classCallCheck(this, TextInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInput).call(this, props));
    _this.state = {
      _id: "".concat(randomString(), "-").concat(props.name),
      value: ''
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autocomplete = _this$props.autocomplete,
          labelComp = _this$props.labelComp,
          labelText = _this$props.labelText,
          name = _this$props.name,
          required = _this$props.required;
      var _this$state = this.state,
          _id = _this$state._id,
          value = _this$state.value;
      var id = this.props.id || _id;
      var Label = labelComp || StyledLabel;
      return React__default.createElement("div", null, labelText ? React__default.createElement(Label, {
        htmlFor: id
      }, labelText, !required || '*') : null, React__default.createElement(StyledInput$2, _extends({
        name: name,
        id: id,
        value: value,
        onChange: function onChange(e) {
          return _this2.setState({
            value: e.target.value
          });
        },
        autoComplete: autocomplete || name
      }, this.props)));
    }
  }]);

  return TextInput;
}(React.Component);

_defineProperty(TextInput$2, "propTypes", {
  name: PropTypes.string.isRequired
});

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 13px;\n  top: 10px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  opacity: 0.3;\n  &:hover {\n    opacity: 1;\n  }\n  &:before,\n  &:after {\n    position: absolute;\n    left: 15px;\n    content: ' ';\n    height: 20px;\n    width: 2px;\n    background-color: #333;\n  }\n  &:before {\n    transform: rotate(45deg);\n  }\n  &:after {\n    transform: rotate(-45deg);\n  }\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  color: #000;\n  width: 100%;\n  max-width: 500px;\n  border-radius: 4px;\n  padding: 20px;\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  text-align: center;\n  z-index: 100;\n  transform: translateX(-50%);\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);\n  opacity: 1;\n  h3 {\n    font-size: 22px;\n    font-weight: 800;\n  }\n  p {\n    font-size: 18px;\n  }\n  &.notification-shown {\n    animation-name: fadeOut;\n    animation-duration: 1s;\n    animation-delay: 6s;\n    animation-iteration-count: 1;\n    animation-direction: forwards;\n  }\n  &.notification-hidden {\n    display: none;\n  }\n  @keyframes fadeOut {\n    from {\n      opacity: 1;\n    }\n    to {\n      opacity: 0;\n      top: -10px;\n    }\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var ConfirmationBox = styled.div(_templateObject$8());
var CloseIcon = styled.div(_templateObject2$8());

var Confirmation =
/*#__PURE__*/
function (_Component) {
  _inherits(Confirmation, _Component);

  function Confirmation() {
    var _this;

    _classCallCheck(this, Confirmation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Confirmation).call(this));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isShowing: true
    });

    _this.handleClickHideAlert = _this.handleClickHideAlert;
    return _this;
  }

  _createClass(Confirmation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleClickShowAlert();
    }
  }, {
    key: "handleClickShowAlert",
    value: function handleClickShowAlert() {
      var _this2 = this;

      this.setState({
        isShowing: true
      });
      setTimeout(function () {
        _this2.setState({
          isShowing: false
        });
      }, 7000);
    }
  }, {
    key: "handleClickHideAlert",
    value: function handleClickHideAlert() {
      this.setState({
        isShowing: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this; // const { article } = this.props;


      var isShowing = this.state.isShowing;
      var _this$props = this.props,
          confirmationText = _this$props.confirmationText,
          confirmationTitle = _this$props.confirmationTitle;
      return React__default.createElement("div", null, React__default.createElement(ConfirmationBox, {
        className: "notification ".concat(isShowing ? 'notification-shown' : 'notification-hidden')
      }, React__default.createElement("h3", null, confirmationTitle || 'Bedankt!'), React__default.createElement("p", null, confirmationText || 'Je e-mailadres is bevestigd. We houden je via e-mail verder op de hoogte, dus houd je inbox in de gaten!'), React__default.createElement(CloseIcon, {
        onClick: function onClick() {
          return _this3.handleClickHideAlert();
        }
      })));
    }
  }]);

  return Confirmation;
}(React.Component);

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  position: relative;\n  padding: 0;\n  margin: 0;\n  a {\n    color: ", ";\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledMenuItem = styled.li(_templateObject$9(), function (_ref) {
  var theme = _ref.theme;
  return getContrastColor({
    backgroundColor: theme.navigationMenuBackgroundColor || '#ffffff',
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
});

var StandardLink = function StandardLink(_ref2) {
  var children = _ref2.children,
      target = _ref2.target,
      to = _ref2.to;
  return React__default.createElement("a", {
    className: "standard",
    href: to,
    target: target
  }, children);
};

var MenuItem =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));
  }

  _createClass(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          current = _this$props.current,
          external = _this$props.external,
          ExternalLink = _this$props.ExternalLink,
          icon = _this$props.icon,
          InternalLink = _this$props.InternalLink,
          special = _this$props.special,
          target = _this$props.target,
          text = _this$props.text,
          to = _this$props.to;
      return React__default.createElement(StyledMenuItem, _extends({}, this.props, {
        className: "".concat(special ? 'special ' : '').concat(current ? 'current ' : '').concat(this.props.className)
      }), external ? React__default.createElement(ExternalLink, {
        to: to,
        target: target
      }, text, icon ? React__default.createElement("img", {
        src: icon,
        alt: ""
      }) : null) : React__default.createElement(InternalLink, {
        to: to,
        target: target
      }, text, icon ? React__default.createElement("img", {
        src: icon,
        alt: ""
      }) : null), children);
    }
  }]);

  return MenuItem;
}(React.Component);

_defineProperty(MenuItem, "propTypes", {
  /** Whether the link is to an external site and should behave differently than an internal link (use the ExternalLink component) */
  external: PropTypes.bool,

  /** Component to use to render an external link */
  ExternalLink: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.shape({
    render: PropTypes.func
  })]),

  /** Url/image code to render an icon next to the link */
  icon: PropTypes.string,

  /** Component to use to render an internal link */
  InternalLink: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.shape({
    render: PropTypes.func
  })]),

  /** Whether to apply a 'special' class, can be used to style CTA buttons, etc */
  special: PropTypes.bool,

  /** Whether to apply a 'current' class */
  current: PropTypes.bool,

  /** Link target */
  target: PropTypes.string,

  /** Link text */
  text: PropTypes.string.isRequired,

  /** Link url */
  to: PropTypes.string.isRequired
});

_defineProperty(MenuItem, "defaultProps", {
  external: false,
  ExternalLink: StandardLink,
  icon: '',
  InternalLink: StandardLink,
  special: false,
  current: false,
  target: ''
});

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  width: 100vw;\n  display: block;\n  position: relative;\n  transition: 0.2s all ease-in-out;\n  &:before {\n    content: '';\n    z-index: -10;\n    background-color: rgba(0, 0, 0, 0);\n    transition: 0.2s background-color linear;\n  }\n  &.chapters {\n    position: fixed;\n  }\n  &.chaptersOpen {\n    margin-left: 0;\n    padding-left: 0;\n    width: calc(100% + 300px);\n    transition: 0.2s all ease-in-out;\n  }\n  &.navOpen {\n    margin-left: ", ";\n    padding-right: ", ";\n    width: calc(100% + 300px);\n    &:before {\n      display: block;\n      position: absolute;\n      height: 100%;\n      width: 100vw;\n      top: 0;\n      content: '';\n      z-index: 99999;\n      background-color: rgba(0, 0, 0, 0.2);\n      transition: 0.2s background-color linear;\n    }\n  }\n  &.fixed {\n    height: 100vh;\n    overflow: hidden;\n  }\n  @media screen and (max-width: 800px) {\n    &.navOpen {\n      margin-left: -100vw;\n      padding-right: 100vw;\n      width: calc(100% + 100vw);\n    }\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var ContentWrapper = styled.div(_templateObject$a(), function (props) {
  return props.left ? '-300px' : '-300px';
}, function (props) {
  return props.left ? '300px' : '300px';
});

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  padding-top: 80px;\n  background-color: ", ";\n  left: ", ";\n  height: calc(100vh + 4px);\n  overflow: scroll;\n  top: -4px;\n  margin: 0;\n  width: 300px;\n  transition: 0.2s all ease-in-out;\n  @media screen and (max-width: 800px) {\n    left: ", ";\n    height: 100vh;\n    border-left: 0;\n    z-index: 20;\n    width: 100vw;\n    transition: 0.4s all ease-in-out;\n  }\n  > ul {\n    display: block;\n    position: relative;\n    width: 100%;\n    margin: 0;\n    padding-top: 80px;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var Menu = styled.ul(_templateObject$b(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor || '#fff';
}, function (props) {
  return props.left ? '-300px' : '100%';
}, function (props) {
  return props.left ? '-300px' : '100vw';
});

var isExternal = function isExternal(url) {
  return url[0] !== '/';
};

var isCurrent = function isCurrent(url) {
  return url === (typeof window !== 'undefined' ? window.location.pathname : '');
};

function SlideMenu(_ref2) {
  var className = _ref2.className,
      customCompBottom = _ref2.customCompBottom,
      customCompTop = _ref2.customCompTop,
      visible = _ref2.visible,
      backgroundColor = _ref2.backgroundColor,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      menuItemComp = _ref2.menuItemComp,
      InternalLink = _ref2.InternalLink,
      ExternalLink = _ref2.ExternalLink,
      left = _ref2.left;
  var Item = menuItemComp || MenuItem;
  var CustomCompTop = customCompTop || React__default.createElement("div", null);
  var CustomCompBottom = customCompBottom || React__default.createElement("div", null);
  return React__default.createElement(Menu, {
    backgroundColor: backgroundColor,
    className: classNames(className || '', {
      visible: visible
    }, 'slide-menu'),
    left: left
  }, customCompTop ? React__default.createElement(CustomCompTop, null) : null, items.map(function (item) {
    return React__default.createElement(Item, {
      text: item.text,
      to: item.url,
      key: "menu-item-".concat(item.text),
      InternalLink: InternalLink,
      ExternalLink: ExternalLink,
      external: isExternal(item.url),
      current: isCurrent(item.url)
    }, !item.items ? null : React__default.createElement("ul", null, item.items.map(function (_item) {
      return React__default.createElement(Item, {
        key: "menu-item-".concat(_item.text),
        text: _item.text,
        to: _item.url,
        InternalLink: InternalLink,
        ExternalLink: ExternalLink,
        external: isExternal(item.url),
        current: isCurrent(item.url)
      });
    })));
  }), customCompBottom ? React__default.createElement(CustomCompBottom, null) : null);
}

var toggleSlideMenu = function toggleSlideMenu(show) {
  var containerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'content-wrapper';
  var toggleClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'navOpen';
  var fixed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var elem = document.getElementById(containerId);
  if (!elem) return;

  if (show === false) {
    elem.classList.add(toggleClass, fixed ? 'fixed' : 'not-fixed');
  } else {
    document.getElementById(containerId).classList.remove(toggleClass, fixed ? 'fixed' : 'not-fixed');
  }
};

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  .hamburger {\n    padding: 14px 14px;\n    display: inline-block;\n    cursor: pointer;\n\n    transition-property: opacity, filter;\n    transition-duration: 0.15s;\n    transition-timing-function: linear;\n\n    font: inherit;\n    color: inherit;\n    text-transform: none;\n    background-color: transparent;\n    border: 0;\n    margin: 0;\n    overflow: visible;\n\n    &:hover {\n      opacity: 0.7;\n    }\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .hamburger-box {\n    width: 40px;\n    height: 24px;\n    display: inline-block;\n    position: relative;\n  }\n\n  .hamburger-inner {\n    display: block;\n    top: 50%;\n    margin-top: 2px;\n\n    &,\n    &::before,\n    &::after {\n      width: 30px;\n      height: 4px;\n      background-color: ", ";\n      border-radius: 4px;\n      position: absolute;\n      transform: all 0.2s linear;\n    }\n\n    &::before,\n    &::after {\n      content: '';\n      display: block;\n    }\n\n    &::before {\n      top: 10px;\n    }\n\n    &::after {\n      bottom: 10px;\n    }\n  }\n  .hamburger--boring {\n    .hamburger-inner {\n      &,\n      &::before,\n      &::after {\n        transition-property: none;\n      }\n    }\n\n    &.is-active {\n      .hamburger-inner {\n        transform: rotate(45deg);\n\n        &::before {\n          top: 0;\n          opacity: 0;\n        }\n\n        &::after {\n          bottom: 0;\n          transform: rotate(-90deg);\n        }\n        &,\n        &::before,\n        &::after {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n  .hamburger--squeeze {\n    .hamburger-inner {\n      transition-duration: 0.075s;\n      transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n\n      &::before {\n        transition: top 0.075s 0.12s ease, opacity 0.075s ease;\n      }\n\n      &::after {\n        transition: bottom 0.075s 0.12s ease,\n          transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n      }\n    }\n\n    &.is-active {\n      .hamburger-inner {\n        transform: rotate(45deg);\n        transition-delay: 0.12s;\n        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n\n        &::before {\n          top: 0;\n          opacity: 0;\n          transition: top 0.075s ease, opacity 0.075s 0.12s ease;\n        }\n\n        &::after {\n          bottom: 0;\n          transform: rotate(-90deg);\n          transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);\n        }\n        &,\n        &::before,\n        &::after {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n  .hamburger--spin {\n    .hamburger-inner {\n      transition-duration: 0.22s;\n      transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n\n      &::before {\n        transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;\n      }\n\n      &::after {\n        transition: bottom 0.1s 0.25s ease-in,\n          transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n      }\n    }\n\n    &.is-active {\n      .hamburger-inner {\n        transform: rotate(225deg);\n        transition-delay: 0.12s;\n        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n\n        &::before {\n          top: 0;\n          opacity: 0;\n          transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;\n        }\n\n        &::after {\n          bottom: 0;\n          transform: rotate(-90deg);\n          transition: bottom 0.1s ease-out,\n            transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);\n        }\n        &,\n        &::before,\n        &::after {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBurger = styled.div(_templateObject$c(), function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var activeColor = _ref2.activeColor;
  return activeColor;
}, function (_ref3) {
  var activeColor = _ref3.activeColor;
  return activeColor;
}, function (_ref4) {
  var activeColor = _ref4.activeColor;
  return activeColor;
});

var Burger = function Burger(_ref5) {
  var active = _ref5.active,
      _ref5$activeColor = _ref5.activeColor,
      activeColor = _ref5$activeColor === void 0 ? '#000000' : _ref5$activeColor,
      _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? '#000000' : _ref5$color,
      hoverColor = _ref5.hoverColor,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? 'boring' : _ref5$type,
      props = _objectWithoutProperties(_ref5, ["active", "activeColor", "color", "hoverColor", "type"]);

  return React__default.createElement(StyledBurger, {
    activeColor: activeColor,
    color: color,
    hoverColor: hoverColor
  }, React__default.createElement("button", _extends({
    className: "hamburger hamburger--".concat(type, " ").concat(active ? 'is-active' : ''),
    type: "button"
  }, props), React__default.createElement("span", {
    className: "hamburger-box"
  }, React__default.createElement("span", {
    className: "hamburger-inner"
  }))));
};

function useWindowDimensions() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  var _useState = React.useState(getSize),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  React.useEffect(function () {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

var ChevronDown = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M434.252,114.203l-21.409-21.416c-7.419-7.04-16.084-10.561-25.975-10.561c-10.095,0-18.657,3.521-25.7,10.561 L222.41,231.549L83.653,92.791c-7.042-7.04-15.606-10.561-25.697-10.561c-9.896,0-18.559,3.521-25.979,10.561l-21.128,21.416 C3.615,121.436,0,130.099,0,140.188c0,10.277,3.619,18.842,10.848,25.693l185.864,185.865c6.855,7.23,15.416,10.848,25.697,10.848 c10.088,0,18.75-3.617,25.977-10.848l185.865-185.865c7.043-7.044,10.567-15.608,10.567-25.693 C444.819,130.287,441.295,121.629,434.252,114.203z"
})), 'chevron-down', '0 0 444.819 444.819');
var ChevronUp = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M433.968,278.657L248.387,92.79c-7.419-7.044-16.08-10.566-25.977-10.566c-10.088,0-18.652,3.521-25.697,10.566 L10.848,278.657C3.615,285.887,0,294.549,0,304.637c0,10.28,3.619,18.843,10.848,25.693l21.411,21.413 c6.854,7.23,15.42,10.852,25.697,10.852c10.278,0,18.842-3.621,25.697-10.852L222.41,213.271L361.168,351.74 c6.848,7.228,15.413,10.852,25.7,10.852c10.082,0,18.747-3.624,25.975-10.852l21.409-21.412 c7.043-7.043,10.567-15.608,10.567-25.693C444.819,294.545,441.205,285.884,433.968,278.657z"
})), 'chevron-up', '0 0 444.819 444.819');
var Email = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M448,64H64C28.656,64,0,92.656,0,128v256c0,35.344,28.656,64,64,64h384c35.344,0,64-28.656,64-64V128 C512,92.656,483.344,64,448,64z M342.656,234.781l135.469-116.094c0.938,3,1.875,6,1.875,9.313v256 c0,2.219-0.844,4.188-1.281,6.281L342.656,234.781z M448,96c2.125,0,4,0.813,6,1.219L256,266.938L58,97.219 C60,96.813,61.875,96,64,96H448z M33.266,390.25C32.828,388.156,32,386.219,32,384V128c0-3.313,0.953-6.313,1.891-9.313 L169.313,234.75L33.266,390.25z M64,416c-3.234,0-6.172-0.938-9.125-1.844l138.75-158.563l51.969,44.531 C248.578,302.719,252.297,304,256,304s7.422-1.281,10.406-3.875l51.969-44.531l138.75,158.563C454.188,415.062,451.25,416,448,416 H64z"
})), 'email', '0 0 512 512');
var Facebook = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M288,176v-64c0-17.664,14.336-32,32-32h32V0h-64c-53.024,0-96,42.976-96,96v80h-64v80h64v256h96V256h64l32-80H288z"
})), 'facebook', '0 0 512 512');
/* eslint-disable */

var Github = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M255.968,5.329C114.624,5.329,0,120.401,0,262.353c0,113.536,73.344,209.856,175.104,243.872 c12.8,2.368,17.472-5.568,17.472-12.384c0-6.112-0.224-22.272-0.352-43.712c-71.2,15.52-86.24-34.464-86.24-34.464 c-11.616-29.696-28.416-37.6-28.416-37.6c-23.264-15.936,1.728-15.616,1.728-15.616c25.696,1.824,39.2,26.496,39.2,26.496 c22.848,39.264,59.936,27.936,74.528,21.344c2.304-16.608,8.928-27.936,16.256-34.368 c-56.832-6.496-116.608-28.544-116.608-127.008c0-28.064,9.984-51.008,26.368-68.992c-2.656-6.496-11.424-32.64,2.496-68 c0,0,21.504-6.912,70.4,26.336c20.416-5.696,42.304-8.544,64.096-8.64c21.728,0.128,43.648,2.944,64.096,8.672 c48.864-33.248,70.336-26.336,70.336-26.336c13.952,35.392,5.184,61.504,2.56,68c16.416,17.984,26.304,40.928,26.304,68.992 c0,98.72-59.84,120.448-116.864,126.816c9.184,7.936,17.376,23.616,17.376,47.584c0,34.368-0.32,62.08-0.32,70.496 c0,6.88,4.608,14.88,17.6,12.352C438.72,472.145,512,375.857,512,262.353C512,120.401,397.376,5.329,255.968,5.329z"
})), 'github', '0 0 512 512');
/* eslint-disable */

var Globe = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "m429.2,82.8c-46.2-46.3-107.8-71.8-173.2-71.8s-127,25.5-173.2,71.8-71.8,107.8-71.8,173.2 25.5,127 71.8,173.2 107.8,71.8 173.2,71.8 127-25.5 173.2-71.8 71.8-107.8 71.8-173.2-25.5-127-71.8-173.2zm49.6,162.2h-95c-0.9-37.8-6.2-74.2-15.5-106.5 18.1-9.3 35-21 50.5-34.8 35,37.4 57.3,86.8 60,141.3zm-211.8,22h94.9c-0.8,34.8-5.6,68.1-13.9,97.9-25.6-10.3-52.9-16.3-81-17.6v-80.3zm136-178.6c-12.8,11.3-26.8,20.9-41.6,28.9-3.8-10.6-8.1-20.6-12.9-30-9.5-18.8-20.3-34.2-32.2-46 32.5,9.1 62,25.4 86.7,47.1zm-136-52c22.9,5.1 44.5,26.2 61.9,60.6 4.7,9.3 8.9,19.2 12.6,29.7-23.5,9.7-48.6,15.4-74.5,16.7v-107zm81.1,111.4c8.2,29.6 12.9,62.7 13.7,97.3h-94.8v-79.6c28.2-1.3 55.5-7.4 81.1-17.7zm-103.1,97.2h-94.9c0.8-34.6 5.5-67.7 13.7-97.3 25.6,10.4 53,16.4 81.1,17.6v79.7zm.1-208.6v107c-25.9-1.3-51.1-7-74.5-16.7 3.7-10.5 7.9-20.4 12.6-29.7 17.4-34.4 39-55.5 61.9-60.6zm-49.3,4.9c-11.9,11.8-22.7,27.3-32.2,46-4.7,9.4-9,19.4-12.9,30-14.8-8-28.7-17.6-41.6-28.9 24.7-21.7 54.2-38 86.7-47.1zm-102.5,62.4c15.5,13.8 32.4,25.4 50.5,34.8-9.3,32.4-14.7,68.7-15.5,106.5h-95c2.7-54.5 25-103.9 60-141.3zm-60,163.3h95c0.9,38.1 6.3,74.6 15.7,107.1-18,9.3-34.9,20.8-50.3,34.6-35.3-37.5-57.7-87-60.4-141.7zm76.2,157c12.8-11.2 26.7-20.8 41.4-28.7 3.8,10.3 8,20.2 12.7,29.4 9.5,18.8 20.3,34.2 32.2,46.1-32.3-9.1-61.7-25.3-86.3-46.8zm135.6,51.6c-22.9-5.1-44.5-26.2-61.9-60.6-4.6-9.1-8.7-18.8-12.4-29.1 23.4-9.7 48.5-15.4 74.3-16.6v106.3zm-81-110.7c-8.3-29.8-13.1-63.1-13.9-97.9h94.9v80.3c-28.1,1.2-55.4,7.2-81,17.6zm103,110.7v-106.3c25.8,1.3 50.9,6.9 74.3,16.6-3.7,10.3-7.8,20-12.4,29.1-17.4,34.4-39,55.5-61.9,60.6zm49.3-4.9c11.9-11.8 22.7-27.3 32.2-46.1 4.7-9.2 8.9-19.1 12.7-29.4 14.7,7.9 28.6,17.5 41.4,28.7-24.6,21.6-54,37.8-86.3,46.8zm102.2-62c-15.4-13.7-32.3-25.3-50.3-34.6 9.4-32.5 14.8-69.1 15.7-107.1h95c-2.8,54.7-25.2,104.2-60.4,141.7z"
})), 'github', '0 0 512 512');
/* eslint-disable */

var Googleplus = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("polygon", {
  points: "448,224 448,160 416,160 416,224 352,224 352,256 416,256 416,320 448,320 448,256 512,256 512,224 \t\t"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M160,224v64h90.528c-13.216,37.248-48.8,64-90.528,64c-52.928,0-96-43.072-96-96c0-52.928,43.072-96,96-96 c22.944,0,45.024,8.224,62.176,23.168l42.048-48.256C235.424,109.824,198.432,96,160,96C71.776,96,0,167.776,0,256 s71.776,160,160,160s160-71.776,160-160v-32H160z"
})))), 'google-plus', '0 0 512 512');
/* eslint-disable */

var Instagram = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160 C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48 h192c61.76,0,112,50.24,112,112V352z"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336 c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("circle", {
  cx: "393.6",
  cy: "118.4",
  r: "17.056"
})))), 'instagram', '0 0 512 512');
/* eslint-disable */

var Linkedin = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("rect", {
  y: "160",
  width: "114.496",
  height: "352"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M426.368,164.128c-1.216-0.384-2.368-0.8-3.648-1.152c-1.536-0.352-3.072-0.64-4.64-0.896 c-6.08-1.216-12.736-2.08-20.544-2.08c-66.752,0-109.088,48.544-123.04,67.296V160H160v352h114.496V320 c0,0,86.528-120.512,123.04-32c0,79.008,0,224,0,224H512V274.464C512,221.28,475.552,176.96,426.368,164.128z"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("circle", {
  cx: "56",
  cy: "56",
  r: "56"
})))), 'linkedin', '0 0 512 512');
/* eslint-disable */

var Pinterest = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M262.948,0C122.628,0,48.004,89.92,48.004,187.968c0,45.472,25.408,102.176,66.08,120.16 c6.176,2.784,9.536,1.6,10.912-4.128c1.216-4.352,6.56-25.312,9.152-35.2c0.8-3.168,0.384-5.92-2.176-8.896 c-13.504-15.616-24.224-44.064-24.224-70.752c0-68.384,54.368-134.784,146.88-134.784c80,0,135.968,51.968,135.968,126.304 c0,84-44.448,142.112-102.208,142.112c-31.968,0-55.776-25.088-48.224-56.128c9.12-36.96,27.008-76.704,27.008-103.36 c0-23.904-13.504-43.68-41.088-43.68c-32.544,0-58.944,32.224-58.944,75.488c0,27.488,9.728,46.048,9.728,46.048 S144.676,371.2,138.692,395.488c-10.112,41.12,1.376,107.712,2.368,113.44c0.608,3.168,4.16,4.16,6.144,1.568 c3.168-4.16,42.08-59.68,52.992-99.808c3.968-14.624,20.256-73.92,20.256-73.92c10.72,19.36,41.664,35.584,74.624,35.584 c98.048,0,168.896-86.176,168.896-193.12C463.62,76.704,375.876,0,262.948,0z"
})), 'pinterest', '0 0 512 512');
/* eslint-disable */

var Reddit = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("polygon", {
  points: "176,289.089 176,289.121 192,289.121 \t\t"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("polygon", {
  points: "336,289.089 336,289.121 352,289.121 \t\t"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M514.24,241.121c0-35.296-28.704-64-64-64c-14.112,0-27.52,4.608-38.464,12.96c-35.712-24.8-82.496-39.584-132.256-43.328 l26.848-62.976l78.112,18.24c2.496,24.16,22.72,43.104,47.52,43.104c26.464,0,48-21.536,48-48s-21.536-48-48-48 c-16.768,0-31.52,8.672-40.096,21.76l-91.296-21.344c-7.744-1.76-15.328,2.176-18.4,9.312l-37.12,87.04 c-53.728,1.856-104.928,16.992-143.584,43.36C90.976,181.441,77.92,177.121,64,177.121c-35.296,0-64,28.704-64,64 c0,23.392,12.768,44.544,32.352,55.392c-0.256,2.816-0.352,5.696-0.352,8.608c0,88.224,100.48,160,224,160 c123.488,0,224-71.776,224-160c0-2.496-0.096-4.96-0.256-7.424C500.608,287.073,514.24,265.409,514.24,241.121z M432,81.121 c8.8,0,16,7.168,16,16c0,8.832-7.2,16-16,16s-16-7.168-16-16C416,88.289,423.2,81.121,432,81.121z M144,289.121 c0-17.632,14.368-32,32-32s32,14.368,32,32c0,17.664-14.368,32-32,32S144,306.785,144,289.121z M329.888,395.265 c-22.08,15.968-48,23.968-73.888,23.968s-51.808-8-73.888-23.968c-7.168-5.184-8.768-15.2-3.584-22.336s15.2-8.736,22.336-3.584 c32.992,23.84,77.28,23.904,110.272,0c7.136-5.152,17.12-3.616,22.336,3.584C338.656,380.097,337.024,390.081,329.888,395.265z M336,321.121c-17.664,0-32-14.336-32-32c0-17.632,14.336-32,32-32s32,14.368,32,32C368,306.785,353.664,321.121,336,321.121z"
})))), 'reddit', '0 0 512 512');
var Rss = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("circle", {
  cx: "64",
  cy: "384",
  r: "64"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M0,149.344v85.344c117.632,0,213.344,95.68,213.344,213.312h85.312C298.656,283.328,164.672,149.344,0,149.344z"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M0,0v85.344C200,85.344,362.688,248,362.688,448H448C448,200.96,247.04,0,0,0z"
})))), 'rss', '0 0 448 448');
var Share = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M16.8636364,0.113908306 C14.5905136,0.113908306 12.7272727,1.95565185 12.7272727,4.20261798 C12.7272727,4.64907363 12.8003591,5.08694298 12.9360636,5.49015266 L6.70170455,9.18571718 C5.99502273,8.62993573 5.10315909,8.29132766 4.13636364,8.29132766 C1.86323136,8.29132766 0,10.1330712 0,12.3800468 C0,14.6270129 1.86323136,16.4687565 4.13636364,16.4687565 C5.10812273,16.4687565 6.00326364,16.1353065 6.71166364,15.5743355 L12.9460227,19.2699 C12.8076773,19.6766008 12.7272727,20.1065129 12.7272727,20.5574661 C12.7272727,22.8044323 14.5905136,24.6461758 16.8636364,24.6461758 C19.1367591,24.6461758 21,22.8044323 21,20.5574661 C21,18.3105 19.1367591,16.4687565 16.8636364,16.4687565 C15.7320545,16.4687565 14.6994273,16.9322274 13.9503,17.6678492 L7.89488636,14.070571 C8.13380909,13.5549218 8.27272727,12.9812129 8.27272727,12.3800468 C8.27272727,11.7709863 8.1298,11.2005704 7.88492727,10.6796688 L13.9403409,7.09223492 C14.6902955,7.83351798 15.7270909,8.29132766 16.8636364,8.29132766 C19.1367591,8.29132766 21,6.44958411 21,4.20261798 C21,1.95565185 19.1367591,0.113908306 16.8636364,0.113908306 Z M16.8636364,2.00100508 C18.1050227,2.00100508 19.0909091,2.97553331 19.0909091,4.20261798 C19.0909091,5.42970266 18.1050227,6.40423089 16.8636364,6.40423089 C15.62225,6.40423089 14.6363636,5.42970266 14.6363636,4.20261798 C14.6363636,2.97553331 15.62225,2.00100508 16.8636364,2.00100508 Z M4.13636364,10.1784244 C5.37775,10.1784244 6.36363636,11.1529527 6.36363636,12.3800468 C6.36363636,13.6071315 5.37775,14.5816597 4.13636364,14.5816597 C2.89498682,14.5816597 1.90909091,13.6071315 1.90909091,12.3800468 C1.90909091,11.1529527 2.89498682,10.1784244 4.13636364,10.1784244 Z M16.8636364,18.3558532 C18.1050227,18.3558532 19.0909091,19.3303815 19.0909091,20.5574661 C19.0909091,21.7845508 18.1050227,22.759079 16.8636364,22.759079 C15.62225,22.759079 14.6363636,21.7845508 14.6363636,20.5574661 C14.6363636,19.3303815 15.62225,18.3558532 16.8636364,18.3558532 Z"
})), 'share', '0 0 21 25');
/* eslint-disable */

var Skype = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M497.28,310.336c3.712-16.672,5.632-33.952,5.632-51.68c0-132.96-109.312-240.768-244.192-240.768 c-14.208,0-28.16,1.216-41.76,3.52C195.136,7.872,169.312,0,141.632,0C63.392,0,0,62.496,0,139.648 c0,25.76,7.104,49.856,19.456,70.624c-3.232,15.616-4.96,31.808-4.96,48.384c0,132.992,109.344,240.8,244.192,240.8 c15.296,0,30.24-1.408,44.736-4.032C323.392,505.984,346.176,512,370.4,512c78.208,0,141.6-62.528,141.6-139.616 C512,350.08,506.688,329.056,497.28,310.336z M383.968,373.728c-11.296,15.776-27.968,28.256-49.632,37.088 c-21.408,8.8-47.04,13.28-76.288,13.28c-35.072,0-64.48-6.08-87.456-18.112c-16.416-8.736-29.92-20.544-40.192-35.2 c-10.4-14.72-15.616-29.344-15.616-43.488c0-8.8,3.424-16.448,10.176-22.688c6.688-6.24,15.264-9.344,25.504-9.344 c8.384,0,15.616,2.464,21.504,7.36c5.6,4.704,10.432,11.68,14.304,20.608c4.32,9.792,9.024,18.048,13.984,24.48 c4.832,6.304,11.712,11.552,20.512,15.68c8.864,4.096,20.8,6.24,35.456,6.24c20.192,0,36.768-4.256,49.184-12.64 c12.192-8.16,18.08-18.016,18.08-30.048c0-9.472-3.104-16.96-9.408-22.816c-6.656-6.144-15.424-10.912-26.048-14.208 c-11.104-3.392-26.176-7.104-44.8-10.944c-25.376-5.344-46.912-11.68-64-18.88c-17.504-7.36-31.648-17.536-41.952-30.272 c-10.496-12.96-15.808-29.184-15.808-48.256c0-18.176,5.568-34.56,16.576-48.704c10.912-14.048,26.848-25.024,47.424-32.48 c20.256-7.392,44.352-11.136,71.648-11.136c21.792,0,40.96,2.496,56.992,7.424c16.096,4.928,29.664,11.584,40.32,19.808 c10.752,8.32,18.752,17.12,23.744,26.336c5.056,9.28,7.648,18.528,7.648,27.456c0,8.608-3.36,16.448-10.016,23.232 c-6.72,6.88-15.168,10.336-25.088,10.336c-9.024,0-16.128-2.208-21.024-6.464c-4.576-4-9.344-10.24-14.592-19.136 c-6.08-11.392-13.472-20.384-21.92-26.752c-8.224-6.176-21.92-9.248-40.8-9.248c-17.472,0-31.744,3.456-42.304,10.304 c-10.176,6.56-15.136,14.112-15.136,23.072c0,5.472,1.6,10.048,4.896,13.984c3.456,4.224,8.352,7.84,14.56,10.912 c6.4,3.168,13.024,5.728,19.648,7.52c6.784,1.856,18.144,4.64,33.792,8.192c19.776,4.16,37.92,8.864,53.984,13.952 c16.288,5.088,30.304,11.392,41.824,18.784c11.68,7.52,20.928,17.12,27.52,28.64c6.592,11.616,9.92,25.856,9.92,42.432 C401.056,339.84,395.296,357.92,383.968,373.728z"
})), 'skype', '0 0 512 512');
/* eslint-disable */

var Spotify = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M256,0C114.848,0,0,114.848,0,256s114.848,256,256,256s256-114.848,256-256S397.152,0,256,0z M373.44,369.536 c-3.136,4.448-8.064,6.816-13.088,6.816c-3.2,0-6.4-0.928-9.184-2.912c-60-42.176-159.808-44.512-227.2-28.8 c-8.544,2.016-17.216-3.36-19.2-11.968c-1.984-8.608,3.328-17.216,11.968-19.232c74.08-17.152,184.8-14.016,252.8,33.824 C376.768,352.352,378.496,362.304,373.44,369.536z M404.672,307.104c-3.136,4.352-8.032,6.656-12.992,6.656 c-3.264,0-6.496-0.96-9.344-3.008c-69.6-49.952-155.104-62.368-269.216-39.072c-8.608,1.696-17.12-3.808-18.88-12.48 c-1.792-8.64,3.808-17.12,12.448-18.88c123.424-25.184,216.928-11.104,294.304,44.416 C408.16,289.92,409.824,299.904,404.672,307.104z M436.224,223.264c-3.104,4.576-8.16,7.008-13.248,7.008 c-3.104,0-6.24-0.896-8.992-2.752c-88.224-59.872-222.336-60.16-309.152-29.44c-8.32,2.88-17.472-1.44-20.416-9.792 c-2.944-8.32,1.408-17.472,9.76-20.416C188.608,134.496,334.944,135.2,432,201.024 C439.296,205.984,441.152,215.936,436.224,223.264z"
})), 'spotify', '0 0 512 512');
var Twitch = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("path", {
  d: "M48,0L16,96v352h128v64h64l64-64h96l128-136.32V0H48z M464,288l-89.6,96H260.928L192,434.144V384H80V32h384V288z"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("rect", {
  x: "240",
  y: "128",
  width: "32",
  height: "128"
}))), React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("rect", {
  x: "336",
  y: "128",
  width: "32",
  height: "128"
})))), 'twitch', '0 0 512 512');
/* eslint-disable */

var Twitter = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016 c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992 c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056 c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152 c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792 c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44 C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568 C480.224,136.96,497.728,118.496,512,97.248z"
})), 'twitter', '0 0 512 512');
/* eslint-disable */

var Vimeo = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M293.792,152.808c58.304-35.008,89.728,14.336,59.84,70.112c-29.952,56-57.44,92.512-71.68,92.512 c-13.984,0-25.056-37.568-41.44-102.784c-16.8-67.552-16.8-189.344-87.072-175.52C87.008,50.248,0,154.248,0,154.248 l20.672,27.232c0,0,42.88-33.824,57.152-16.992c14.464,16.992,69.216,221.024,87.328,258.752 c15.808,33.056,59.68,76.672,107.616,45.568c48.384-31.296,208.096-167.68,236.704-329.056 C538.016-21.336,316.96,12.392,293.792,152.808z"
})), 'video', '0 0 512 512');
/* eslint-disable */

var Whatsapp = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456 C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504 c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792 c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184 c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392 c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352 c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024 c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568 c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z"
})), 'whatsapp', '0 0 512 512');
/* eslint-disable */

var Youtube = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M490.24,113.92c-13.888-24.704-28.96-29.248-59.648-30.976C399.936,80.864,322.848,80,256.064,80 c-66.912,0-144.032,0.864-174.656,2.912c-30.624,1.76-45.728,6.272-59.744,31.008C7.36,138.592,0,181.088,0,255.904 C0,255.968,0,256,0,256c0,0.064,0,0.096,0,0.096v0.064c0,74.496,7.36,117.312,21.664,141.728 c14.016,24.704,29.088,29.184,59.712,31.264C112.032,430.944,189.152,432,256.064,432c66.784,0,143.872-1.056,174.56-2.816 c30.688-2.08,45.76-6.56,59.648-31.264C504.704,373.504,512,330.688,512,256.192c0,0,0-0.096,0-0.16c0,0,0-0.064,0-0.096 C512,181.088,504.704,138.592,490.24,113.92z M192,352V160l160,96L192,352z"
})), 'youtube', '0 0 512 512');
var Icons = {
  ChevronDown: ChevronDown,
  ChevronUp: ChevronUp,
  Email: Email,
  Facebook: Facebook,
  Github: Github,
  Globe: Globe,
  Googleplus: Googleplus,
  Instagram: Instagram,
  Linkedin: Linkedin,
  Pinterest: Pinterest,
  Reddit: Reddit,
  Rss: Rss,
  Share: Share,
  Skype: Skype,
  Spotify: Spotify,
  Twitch: Twitch,
  Twitter: Twitter,
  Vimeo: Vimeo,
  Whatsapp: Whatsapp,
  Youtube: Youtube
};

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: inline-block;\n  vertical-align: middle;\n  width: 40px;\n  height: 100%;\n  svg {\n    fill: ", ";\n    margin-top: 15px;\n    width: 20px;\n    margin-left: 2px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: absolute;\n  top: ", ";\n  transform: ", ";\n  left: 0;\n  overflow: auto;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  height: auto;\n  max-height: 275px;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  transition: all 0.1s ease-in-out;\n  margin-left: 40px;\n  &:hover {\n    background-color: ", ";\n    color: #fff;\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  cursor: default;\n  display: inline-block;\n  vertical-align: middle;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 50px;\n  width: calc(100% - 40px);\n  background-color: transparent;\n  line-height: 50px;\n  background-color: ", ";\n  text-align: left;\n  padding-left: 20px;\n  @media screen and (max-width: 800px) {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  overflow: visible;\n  height: 50px;\n  width: 100%;\n  .translations {\n    display: none;\n  }\n  &:hover {\n    .translations {\n      display: block;\n    }\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var Globe$1 = Icons.Globe;
var Wrapper = styled.div(_templateObject$d());
var Item = styled.div(_templateObject2$9(), function (_ref) {
  var theme = _ref.theme;
  return theme.navigationLanguagePickerColor;
});
var Current = styled(Item)(_templateObject3$5(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.navigationLanguagePickerColor;
});
var Translation = styled(Item)(_templateObject4$2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.navigationLanguagePickerHoverColor;
});
var Translations = styled.div(_templateObject5$2(), function (_ref4) {
  var showAbove = _ref4.showAbove;
  return showAbove ? '0' : '100%';
}, function (_ref5) {
  var showAbove = _ref5.showAbove;
  return showAbove ? 'translateY(-100%)' : 'initial';
});
var Icon = styled.div(_templateObject6(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.navigationLanguagePickerColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.navigationLanguagePickerIconColor;
});

var LanguagePicker = function LanguagePicker(_ref8) {
  var _ref8$current = _ref8.current,
      current = _ref8$current === void 0 ? 'en' : _ref8$current,
      _ref8$translations = _ref8.translations,
      translations = _ref8$translations === void 0 ? [] : _ref8$translations,
      _ref8$onTranslationCl = _ref8.onTranslationClick,
      onTranslationClick = _ref8$onTranslationCl === void 0 ? function () {} : _ref8$onTranslationCl,
      _ref8$showAbove = _ref8.showAbove,
      showAbove = _ref8$showAbove === void 0 ? false : _ref8$showAbove;
  var windowDimensions = useWindowDimensions();
  return React__default.createElement(Wrapper, null, React__default.createElement(Icon, null, React__default.createElement(Globe$1, null)), React__default.createElement(Current, null, windowDimensions.width > 800 ? current.name : current.locale), React__default.createElement(Translations, {
    className: "translations",
    showAbove: showAbove
  }, translations.map(function (trans) {
    return React__default.createElement(Translation, {
      key: trans.locale,
      onClick: function onClick(e) {
        e.preventDefault();
        onTranslationClick(trans, {
          event: e
        });
      }
    }, windowDimensions.width > 800 ? trans.name : trans.locale);
  })));
};

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  color: ", ";\n  margin: ", ";\n  padding: ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var CaptionWrapper = styled.figcaption(_templateObject$e(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var borderStyle = _ref2.borderStyle;
  return borderStyle;
}, function (_ref3) {
  var borderColor = _ref3.borderColor;
  return borderColor;
}, function (_ref4) {
  var borderWidth = _ref4.borderWidth;
  return borderWidth;
}, function (_ref5) {
  var textColor = _ref5.textColor;
  return textColor;
}, function (_ref6) {
  var margin = _ref6.margin;
  return margin;
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding;
});

var Caption =
/*#__PURE__*/
function (_Component) {
  _inherits(Caption, _Component);

  function Caption() {
    _classCallCheck(this, Caption);

    return _possibleConstructorReturn(this, _getPrototypeOf(Caption).apply(this, arguments));
  }

  _createClass(Caption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      return React__default.createElement(CaptionWrapper, props, children);
    }
  }]);

  return Caption;
}(React.Component);

_defineProperty(Caption, "propTypes", {
  /** Border color, a CSS border-color value, e.g. '#fff' or 'transparent transparent transparent #ddd' */
  borderColor: PropTypes.string,

  /** Border style, a CSS border-style value, e.g. 'solid' or 'none none none dashed' */
  borderStyle: PropTypes.string,

  /** Border width, a CSS border-width value, e.g. '2px' or '1px 1rem 1em 0' */
  borderWidth: PropTypes.string,

  /** Background color, a CSS color value, e.g. '#fff' or 'rgba(255,255,255,1)' for white */
  backgroundColor: PropTypes.string,

  /** margins, e.g. '1rem 0' */
  margin: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  padding: PropTypes.string,

  /** Text color, a CSS color value, e.g. '#000' or 'rgba(0,0,0,1)' for black */
  textColor: PropTypes.string
});

_defineProperty(Caption, "defaultProps", {
  backgroundColor: '#fff',
  borderColor: 'transparent',
  borderStyle: 'none',
  borderWidth: '0',
  margin: '0',
  padding: '.75rem 0 0 0',
  textColor: '#000'
});

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  font-weight: bold;\n  font-family: ", ";\n  line-height: 50px;\n  position: absolute;\n  height: 50px;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  cursor: pointer;\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n  ", ";\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: 30px;\n  margin: 40px 0;\n  transition: all 0.2s linear;\n  width: 100%;\n  position: relative;\n  > * {\n    width: 100%;\n    max-width: 720px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  ", ";\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var ExpandableWrapper = styled.div(_templateObject$f(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return "rgb(".concat(backgroundColor, ")");
}, function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return "".concat(borderRadius || 4, "px");
}, function (_ref3) {
  var shadow = _ref3.shadow;
  return shadow ? '0 0 20px 0 rgba(0, 0, 0, 0.05)' : 'none';
}, function (props) {
  if (props.expandable) {
    if (!props.open) {
      return "\n          height: ".concat(props.height || '250px', ";\n          overflow: hidden;\n          padding-bottom: 50px;\n        ");
    }

    return "\n        height: auto;\n        overflow: hidden;\n        padding-bottom: 50px;\n      ";
  }

  return '';
});
var Toggle = styled.div(_templateObject2$a(), function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return "rgb(".concat(backgroundColor, ")");
}, function (_ref5) {
  var toggleColor = _ref5.toggleColor;
  return toggleColor;
}, function (_ref6) {
  var toggleFontFamily = _ref6.toggleFontFamily;
  return toggleFontFamily;
}, function (_ref7) {
  var toggleHoverColor = _ref7.toggleHoverColor;
  return toggleHoverColor;
}, function (_ref8) {
  var open = _ref8.open,
      backgroundColor = _ref8.backgroundColor;
  return !open ? "&:after {\n    display: block;\n    position: absolute;\n    background-image: linear-gradient(to bottom, rgba(".concat(backgroundColor, ", 0) 0, rgba(").concat(backgroundColor, ", 100) 100%);\n    top: -50px;\n    height: 50px;\n    width: 100%;\n    content: '';\n  }") : null;
});

var Expandable =
/*#__PURE__*/
function (_Component) {
  _inherits(Expandable, _Component);

  function Expandable(props) {
    var _this;

    _classCallCheck(this, Expandable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Expandable).call(this, props));
    _this.state = {
      open: false
    };
    _this.boundToggleHeight = _this.toggleHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Expandable, [{
    key: "toggleHeight",
    value: function toggleHeight() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          borderRadius = _this$props.borderRadius,
          children = _this$props.children,
          closeText = _this$props.closeText,
          expandable = _this$props.expandable,
          height = _this$props.height,
          openText = _this$props.openText,
          shadow = _this$props.shadow,
          toggleColor = _this$props.toggleColor,
          toggleHoverColor = _this$props.toggleHoverColor,
          toggleFontFamily = _this$props.toggleFontFamily;
      var open = this.state.open;
      return React__default.createElement(ExpandableWrapper, {
        expandable: expandable,
        open: open,
        height: height,
        backgroundColor: backgroundColor,
        shadow: shadow,
        borderRadius: borderRadius
      }, children, expandable ? React__default.createElement(Toggle, {
        backgroundColor: backgroundColor,
        onClick: this.boundToggleHeight,
        open: open,
        toggleColor: toggleColor,
        toggleHoverColor: toggleHoverColor,
        toggleFontFamily: toggleFontFamily
      }, open ? closeText : openText) : null);
    }
  }]);

  return Expandable;
}(React.Component);

_defineProperty(Expandable, "propTypes", {
  /** Background color, must be an rgb value, e.g. '255, 255, 255' for white */
  backgroundColor: PropTypes.string,

  /** Border radius, pixels. Default = 4 */
  borderRadius: PropTypes.string,

  /** Text for the close button */
  closeText: PropTypes.string,

  /** Determines whether that block can be expanded */
  expandable: PropTypes.bool,

  /** The height of the unexpanded block */
  height: PropTypes.string,

  /** Text for the open button */
  openText: PropTypes.string,

  /** Toggles background shadow for the card. */
  shadow: PropTypes.bool,

  /** Open/close text color */
  toggleColor: PropTypes.string,

  /** Open/close text hover color */
  toggleHoverColor: PropTypes.string,

  /** Open/close text font family */
  toggleFontFamily: PropTypes.string
});

_defineProperty(Expandable, "defaultProps", {
  backgroundColor: '255, 255, 255',
  borderRadius: '4',
  closeText: 'Less',
  expandable: true,
  height: '250px',
  openText: 'More',
  shadow: true,
  toggleColor: '#000000',
  toggleHoverColor: '#4856C9',
  toggleFontFamily: 'initial'
});

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  i,\n  em {\n    font-style: italic;\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var QuoteWrapper = styled.blockquote(_templateObject$g(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var borderStyle = _ref2.borderStyle;
  return borderStyle;
}, function (_ref3) {
  var borderColor = _ref3.borderColor;
  return borderColor;
}, function (_ref4) {
  var borderWidth = _ref4.borderWidth;
  return borderWidth;
}, function (_ref5) {
  var textColor = _ref5.textColor;
  return textColor;
}, function (_ref6) {
  var textSize = _ref6.textSize;
  return textSize;
}, function (_ref7) {
  var fontWeight = _ref7.fontWeight;
  return fontWeight;
}, function (_ref8) {
  var lineHeight = _ref8.lineHeight;
  return lineHeight;
}, function (_ref9) {
  var margin = _ref9.margin;
  return margin;
}, function (_ref10) {
  var padding = _ref10.padding;
  return padding;
}, function (_ref11) {
  var textAlign = _ref11.textAlign;
  return textAlign;
});

var Quote =
/*#__PURE__*/
function (_Component) {
  _inherits(Quote, _Component);

  function Quote() {
    _classCallCheck(this, Quote);

    return _possibleConstructorReturn(this, _getPrototypeOf(Quote).apply(this, arguments));
  }

  _createClass(Quote, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      return React__default.createElement(QuoteWrapper, props, children);
    }
  }]);

  return Quote;
}(React.Component);

_defineProperty(Quote, "propTypes", {
  /** Border color, a CSS border-color value, e.g. '#fff' or 'transparent transparent transparent #ddd' */
  borderColor: PropTypes.string,

  /** Border style, a CSS border-style value, e.g. 'solid' or 'none none none dashed' */
  borderStyle: PropTypes.string,

  /** Border width, a CSS border-width value, e.g. '2px' or '1px 1rem 1em 0' */
  borderWidth: PropTypes.string,

  /** Background color, a CSS color value, e.g. '#fff' or 'rgba(255,255,255,1)' for white */
  backgroundColor: PropTypes.string,

  /** Font weight value, e.g. '700', 'bold', 'thinner' */
  fontWeight: PropTypes.string,

  /** Line height, a line-height value, e.g. '1.4' */
  lineHeight: PropTypes.string,

  /** margins, e.g. '1rem 0' */
  margin: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  padding: PropTypes.string,

  /** Text-align value */
  textAlign: PropTypes.oneOf(['left', 'right', 'center', 'justify', 'justify-all', 'start', 'end', 'match-parent', 'inherit', 'initial', 'unset']),

  /** Text color, a CSS color value, e.g. '#000' or 'rgba(0,0,0,1)' for black */
  textColor: PropTypes.string,

  /** Text size, a CSS font-size value, e.g. '12px' or '1.5rem' */
  textSize: PropTypes.string
});

_defineProperty(Quote, "defaultProps", {
  backgroundColor: '#fff',
  borderColor: 'transparent transparent transparent #ddd',
  borderStyle: 'none none none solid',
  borderWidth: '0 0 0 .5rem',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  margin: '0',
  padding: '0 0 0 1rem',
  textAlign: 'inherit',
  textColor: '#000',
  textSize: '1rem'
});

function SvgIcon$1(props) {
  var children = props.children,
      Component = props.component,
      title = props.title,
      viewBox = props.viewBox,
      other = _objectWithoutProperties(props, ["children", "component", "title", "viewBox"]);

  var ariaLabelledby = title ? "".concat(randomString(), "-").concat(classNameFromString(title)) : null;
  return React__default.createElement(Component, _extends({
    focusable: "false",
    viewBox: viewBox,
    "aria-hidden": title ? 'false' : 'true',
    role: title ? 'img' : 'presentation',
    "aria-labelledby": ariaLabelledby
  }, other), children, title ? React__default.createElement("title", {
    id: ariaLabelledby
  }, title) : null);
}

SvgIcon$1.propTypes = {
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node.isRequired,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
};
SvgIcon$1.defaultProps = {
  component: 'svg',
  viewBox: '0 0 24 24'
};
SvgIcon$1.craneName = 'SvgIcon';
createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M358.967,1.614c-5.6-2.72-12.128-1.952-16.928,1.92L186.391,128.046h-74.368c-17.664,0-32,14.336-32,32v128  c0,17.664,14.336,32,32,32h74.368l155.616,124.512c2.912,2.304,6.464,3.488,10.016,3.488c2.336,0,4.704-0.544,6.944-1.6  c5.536-2.656,9.056-8.256,9.056-14.4v-416C368.023,9.902,364.503,4.302,358.967,1.614z"
})), 'audio-on', '0 0 448.046 448.046');
createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M352.021,16.075c0-6.08-3.52-11.84-8.96-14.4c-5.76-2.88-12.16-1.92-16.96,1.92l-141.76,112.96l167.68,167.68V16.075z"
}), React__default.createElement("path", {
  d: "M443.349,420.747l-416-416c-6.24-6.24-16.384-6.24-22.624,0s-6.24,16.384,0,22.624l100.672,100.704h-9.376  c-9.92,0-18.56,4.48-24.32,11.52c-4.8,5.44-7.68,12.8-7.68,20.48v128c0,17.6,14.4,32,32,32h74.24l155.84,124.48  c2.88,2.24,6.4,3.52,9.92,3.52c2.24,0,4.8-0.64,7.04-1.6c5.44-2.56,8.96-8.32,8.96-14.4v-57.376l68.672,68.672  c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C449.589,437.131,449.589,427.019,443.349,420.747z"
})), 'audio-on', '0 0 448.046 448.046');
var Calendar = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("rect", {
  x: "3",
  y: "4",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2"
}), React__default.createElement("line", {
  x1: "16",
  y1: "2",
  x2: "16",
  y2: "6"
}), React__default.createElement("line", {
  x1: "8",
  y1: "2",
  x2: "8",
  y2: "6"
}), React__default.createElement("line", {
  x1: "3",
  y1: "10",
  x2: "21",
  y2: "10"
})), 'calendar');
var Check = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
}), React__default.createElement("polyline", {
  points: "22 4 12 14.01 9 11.01"
})), 'check');
var ChevronLeft = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("polyline", {
  points: "15 18 9 12 15 6"
})), 'chevronLeft');
var ChevronRight = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("polyline", {
  points: "9 18 15 12 9 6"
})), 'chevronRight');
var Envelope = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
}), React__default.createElement("polyline", {
  points: "22,6 12,13 2,6"
})), 'envelope');
createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
}), React__default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3"
})), 'eye');
var Message = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
})), 'message');
var Pause = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("rect", {
  x: "6",
  y: "4",
  width: "4",
  height: "16"
}), React__default.createElement("rect", {
  x: "14",
  y: "4",
  width: "4",
  height: "16"
}), ' '), 'pause');
var Pin = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
}), React__default.createElement("circle", {
  cx: "12",
  cy: "10",
  r: "3"
})), 'pin');
var Play = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("polygon", {
  points: "5 3 19 12 5 21 5 3"
})), 'play');
var QuoteIcon = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M6.52983268,3 L10.195704,5.93416928 C8.36276834,6.8369906 5.95704051,9.2633229 5.38424834,11.2946708 C5.61336511,11.2382445 6.12887847,11.1253918 6.70167064,11.1253918 C9.10739847,11.1253918 11.1121721,12.9874608 11.1121721,15.7523511 C11.1121721,18.6300941 8.70644374,21 5.84248187,21 C2.74940323,21 0,18.5736677 0,14.4545455 C0,9.8275862 2.52028647,5.82131662 6.52983268,3 Z M19.4176611,3 L23.0835324,5.93416928 C21.2505968,6.8369906 18.9021477,9.2633229 18.2720763,11.2946708 C18.5011935,11.2382445 19.0167064,11.1253918 19.5894986,11.1253918 C22.0525062,11.1253918 24,12.9874608 24,15.7523511 C24,18.6300941 21.5942722,21 18.7875896,21 C15.694511,21 12.8878279,18.5736677 12.8878279,14.4545455 C12.8878279,9.8275862 15.4081144,5.82131662 19.4176611,3 Z"
})), 'quote');
var User = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
}), React__default.createElement("circle", {
  cx: "12",
  cy: "7",
  r: "4"
}), ' '), 'user');

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  &:before {\n    content: '\u2014';\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  svg {\n    fill: ", ";\n    width: 48px;\n    height: 48px;\n  }\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  position: relative;\n  blockquote {\n    > *:first-child {\n      margin-top: 0;\n    }\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var BlockquoteWrapper = styled('figure')(_templateObject$h(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var shadow = _ref2.shadow;
  return shadow;
}, function (_ref3) {
  var wrapperMargin = _ref3.wrapperMargin;
  return wrapperMargin;
}, function (_ref4) {
  var wrapperPadding = _ref4.wrapperPadding;
  return wrapperPadding;
}, function (_ref5) {
  var textAlign = _ref5.textAlign;
  return textAlign;
});
var BlockquoteIcon = styled('span')(_templateObject2$b(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.iconColor;
});
var Attribution = styled(Caption)(_templateObject3$6());

var Blockquote =
/*#__PURE__*/
function (_Component) {
  _inherits(Blockquote, _Component);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, _getPrototypeOf(Blockquote).apply(this, arguments));
  }

  _createClass(Blockquote, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attribution = _this$props.attribution,
          backgroundColor = _this$props.backgroundColor,
          decorationIcon = _this$props.decorationIcon,
          hasDecoration = _this$props.hasDecoration,
          shadow = _this$props.shadow,
          textAlign = _this$props.textAlign,
          wrapperMargin = _this$props.wrapperMargin,
          wrapperPadding = _this$props.wrapperPadding,
          attributionPadding = _this$props.attributionPadding,
          props = _objectWithoutProperties(_this$props, ["attribution", "backgroundColor", "decorationIcon", "hasDecoration", "shadow", "textAlign", "wrapperMargin", "wrapperPadding", "attributionPadding"]);

      return React__default.createElement(BlockquoteWrapper, {
        backgroundColor: backgroundColor,
        shadow: shadow,
        textAlign: textAlign,
        wrapperMargin: wrapperMargin,
        wrapperPadding: wrapperPadding
      }, hasDecoration ? React__default.createElement(BlockquoteIcon, null, decorationIcon) : null, React__default.createElement(Quote, _extends({
        backgroundColor: "transparent"
      }, props)), attribution ? React__default.createElement(Attribution, {
        backgroundColor: "transparent",
        padding: attributionPadding
      }, attribution) : null);
    }
  }]);

  return Blockquote;
}(React.Component);

_defineProperty(Blockquote, "propTypes", {
  /** Attribution of quote */
  attribution: PropTypes.string,

  /** Background color, a CSS color value, e.g. '#fff' or 'rgba(255,255,255,1)' for white */
  backgroundColor: PropTypes.string,

  /** Border color, a CSS border-color value, e.g. '#fff' or 'transparent transparent transparent #ddd' */
  borderColor: PropTypes.string,

  /** Border style, a CSS border-style value, e.g. 'solid' or 'none none none dashed' */
  borderStyle: PropTypes.string,

  /** Border width, a CSS border-width value, e.g. '2px' or '1px 1rem 1em 0' */
  borderWidth: PropTypes.string,

  /** decoration icon */
  decorationIcon: PropTypes.element,

  /** Font weight value, e.g. '700', 'bold', 'thinner' */
  fontWeight: PropTypes.string,

  /** show a decorative icon */
  hasDecoration: PropTypes.bool,

  /** Line height, a line-height value, e.g. '1.4' */
  lineHeight: PropTypes.string,

  /** margins, e.g. '1rem 0' */
  margin: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  padding: PropTypes.string,

  /** Box shadow, a CSS box-shadow value, e.g. '0 0 10px 0 rgba(0,0,0,0.5)' */
  shadow: PropTypes.string,

  /** Text-align value */
  textAlign: PropTypes.oneOf(['left', 'right', 'center', 'justify', 'justify-all', 'start', 'end', 'match-parent', 'inherit', 'initial', 'unset']),

  /** Text color, a CSS color value, e.g. '#000' or 'rgba(0,0,0,1)' for black */
  textColor: PropTypes.string,

  /** Text size, a CSS font-size value, e.g. '12px' or '1.5rem' */
  textSize: PropTypes.string,

  /** margins, e.g. '1rem 0' */
  wrapperMargin: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  wrapperPadding: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  attributionPadding: PropTypes.string
});

_defineProperty(Blockquote, "defaultProps", {
  attribution: '',
  backgroundColor: '#fff',
  borderColor: '#4856C9',
  borderStyle: 'none none none solid',
  borderWidth: '5px',
  decorationIcon: React__default.createElement(QuoteIcon, null),
  fontWeight: 'inherit',
  hasDecoration: false,
  lineHeight: 'inherit',
  margin: '0',
  wrapperMargin: '1rem 0 1rem calc(calc(1rem + 5px) * -1)',
  wrapperPadding: '0',
  padding: '0 0 0 1rem',
  shadow: 'none',
  textAlign: 'inherit',
  textColor: '#000',
  textSize: 'inherit',
  attributionPadding: '.5rem 0 0 calc(1rem + 5px)'
});

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  &:before {\n    content: '\u2014';\n  }\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  > *:first-child {\n    margin-top: 0;\n  }\n  > *:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ";\n  float: ", ";\n  margin: ", ";\n  max-width: ", ";\n  padding: ", ";\n  text-align: ", ";\n  @media screen and (min-width: 700px) {\n    &.left,\n    &.right {\n      float: none;\n      max-width: none;\n      margin: inherit 0;\n    }\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper$1 = styled('figure')(_templateObject$i(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var shadow = _ref2.shadow;
  return shadow;
}, function (_ref3) {
  var _float = _ref3["float"];
  return _float;
}, function (_ref4) {
  var wrapperMargin = _ref4.wrapperMargin;
  return wrapperMargin;
}, function (_ref5) {
  var maxWidth = _ref5.maxWidth;
  return maxWidth;
}, function (_ref6) {
  var wrapperPadding = _ref6.wrapperPadding;
  return wrapperPadding;
}, function (_ref7) {
  var textAlign = _ref7.textAlign;
  return textAlign;
});
var StyledQuote = styled(Quote)(_templateObject2$c());
var Attribution$1 = styled(Caption)(_templateObject3$7());

var HighlightedQuote =
/*#__PURE__*/
function (_Component) {
  _inherits(HighlightedQuote, _Component);

  function HighlightedQuote() {
    _classCallCheck(this, HighlightedQuote);

    return _possibleConstructorReturn(this, _getPrototypeOf(HighlightedQuote).apply(this, arguments));
  }

  _createClass(HighlightedQuote, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attribution = _this$props.attribution,
          backgroundColor = _this$props.backgroundColor,
          _float2 = _this$props["float"],
          maxWidth = _this$props.maxWidth,
          shadow = _this$props.shadow,
          type = _this$props.type,
          wrapperMargin = _this$props.wrapperMargin,
          wrapperPadding = _this$props.wrapperPadding,
          textAlign = _this$props.textAlign,
          props = _objectWithoutProperties(_this$props, ["attribution", "backgroundColor", "float", "maxWidth", "shadow", "type", "wrapperMargin", "wrapperPadding", "textAlign"]);

      return React__default.createElement(Wrapper$1, {
        backgroundColor: backgroundColor,
        "float": _float2,
        maxWidth: maxWidth,
        shadow: shadow,
        className: "".concat(type),
        wrapperMargin: wrapperMargin,
        wrapperPadding: wrapperPadding,
        textAlign: textAlign
      }, React__default.createElement(StyledQuote, _extends({
        backgroundColor: "transparent",
        type: type
      }, props)), attribution ? React__default.createElement(Attribution$1, {
        backgroundColor: "transparent"
      }, attribution) : null);
    }
  }]);

  return HighlightedQuote;
}(React.Component);

_defineProperty(HighlightedQuote, "propTypes", {
  /** Attribution of quote */
  attribution: PropTypes.string,

  /** Background color, a CSS color value, e.g. '#fff' or 'rgba(255,255,255,1)' for white */
  backgroundColor: PropTypes.string,

  /** Border color, a CSS border-color value, e.g. '#fff' or 'transparent transparent transparent #ddd' */
  borderColor: PropTypes.string,

  /** Border style, a CSS border-style value, e.g. 'solid' or 'none none none dashed' */
  borderStyle: PropTypes.string,

  /** Border width, a CSS border-width value, e.g. '2px' or '1px 1rem 1em 0' */
  borderWidth: PropTypes.string,

  /** float */
  "float": PropTypes.oneOf(['none', 'left', 'right', 'inline-start', 'inline-end', 'inherit', 'initial', 'unset']),

  /** Font weight value, e.g. '700', 'bold', 'thinner' */
  fontWeight: PropTypes.string,

  /** Line height, a line-height value, e.g. '1.4' */
  lineHeight: PropTypes.string,

  /** margins, e.g. '1rem 0' */
  margin: PropTypes.string,

  /** max-width, e.g. '50%' */
  maxWidth: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  padding: PropTypes.string,

  /** Box shadow, a CSS box-shadow value, e.g. '0 0 10px 0 rgba(0,0,0,0.5)' */
  shadow: PropTypes.string,

  /** Text-align value */
  textAlign: PropTypes.oneOf(['left', 'right', 'center', 'justify', 'justify-all', 'start', 'end', 'match-parent', 'inherit', 'initial', 'unset']),

  /** Text color, a CSS color value, e.g. '#000' or 'rgba(0,0,0,1)' for black */
  textColor: PropTypes.string,

  /** Text size, a CSS font-size value, e.g. '12px' or '1.5rem' */
  textSize: PropTypes.string,

  /** margins, e.g. '1rem 0' */
  wrapperMargin: PropTypes.string,

  /** padding, e.g. '1rem 0' */
  wrapperPadding: PropTypes.string
});

_defineProperty(HighlightedQuote, "defaultProps", {
  attribution: '',
  backgroundColor: '#fff',
  borderColor: 'transparent',
  borderStyle: 'none',
  borderWidth: '0',
  "float": 'none',
  fontWeight: 'bolder',
  lineHeight: '1',
  margin: '0',
  maxWidth: 'none',
  padding: '0',
  shadow: 'none',
  textAlign: 'center',
  textColor: '#4856C9',
  textSize: '3rem',
  wrapperMargin: '3rem 0',
  wrapperPadding: '0'
});

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: left;\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  margin-bottom: 20px;\n  line-height: 1;\n  font-size: 24px;\n  @media screen and (min-width: 800px) {\n    margin-bottom: 20px;\n    font-size: 32px;\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var Title$3 = styled.h4(_templateObject$j(), function (_ref) {
  var theme = _ref.theme;
  return theme.headingColor;
});
var Text = styled.p(_templateObject2$d(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor;
});

var Breakout =
/*#__PURE__*/
function (_Component) {
  _inherits(Breakout, _Component);

  function Breakout(props) {
    var _this;

    _classCallCheck(this, Breakout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Breakout).call(this, props));
    _this.state = {
      open: false
    };
    _this.boundToggleHeight = _this.toggleHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Breakout, [{
    key: "toggleHeight",
    value: function toggleHeight() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          title = _this$props.title,
          closeText = _this$props.closeText,
          openText = _this$props.openText,
          expandable = _this$props.expandable,
          height = _this$props.height,
          toggleColor = _this$props.toggleColor,
          toggleHoverColor = _this$props.toggleHoverColor,
          toggleFontFamily = _this$props.toggleFontFamily,
          borderRadius = _this$props.borderRadius,
          backgroundColor = _this$props.backgroundColor,
          shadow = _this$props.shadow;
      var open = this.state.open;
      console.log(openText, closeText);
      return React__default.createElement(Expandable, {
        expandable: expandable,
        open: open,
        height: height,
        toggleColor: toggleColor,
        toggleHoverColor: toggleHoverColor,
        toggleFontFamily: toggleFontFamily,
        borderRadius: borderRadius,
        backgroundColor: backgroundColor,
        shadow: shadow,
        closeText: closeText,
        openText: openText
      }, title ? React__default.createElement(Title$3, null, title) : null, React__default.createElement(Text, null, text));
    }
  }]);

  return Breakout;
}(React.Component);

_defineProperty(Breakout, "propTypes", {
  /** Background color, must be an rgb value, e.g. '255, 255, 255' for white */
  backgroundColor: PropTypes.string,

  /** Border radius, pixels. Default = 4 */
  borderRadius: PropTypes.string,

  /** Text for the close button */
  closeText: PropTypes.string,

  /** Determines whether that block can be expanded */
  expandable: PropTypes.bool,

  /** The height of the unexpanded block */
  height: PropTypes.string,

  /** Text for the open button */
  openText: PropTypes.string,

  /** Toggles background shadow for the card. */
  shadow: PropTypes.bool,

  /** Text content */
  text: PropTypes.string.isRequired,

  /** Title content */
  title: PropTypes.string,

  /** Open/close text color */
  toggleColor: PropTypes.string,

  /** Open/close text hover color */
  toggleHoverColor: PropTypes.string,

  /** Open/close text font family */
  toggleFontFamily: PropTypes.string
});

_defineProperty(Breakout, "defaultProps", {
  backgroundColor: '255, 255, 255',
  borderRadius: '4',
  closeText: 'Less',
  expandable: true,
  height: '250px',
  openText: 'More',
  shadow: true,
  title: '',
  toggleColor: '#000000',
  toggleHoverColor: '#4856C9',
  toggleFontFamily: 'initial'
});

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  margin: ", ";\n  padding: ", ";\n  > li {\n    margin: ", ";\n    padding: ", ";\n    position: relative;\n    ", ";\n  }\n  "]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUl = styled.ul(_templateObject$k(), function (_ref) {
  var margin = _ref.margin;
  return margin || 'initial';
}, function (_ref2) {
  var padding = _ref2.padding;
  return padding || 'initial';
}, function (_ref3) {
  var itemMargin = _ref3.itemMargin;
  return itemMargin || 'initial';
}, function (_ref4) {
  var itemPadding = _ref4.itemPadding;
  return itemPadding || 'initial';
}, function (_ref5) {
  var bulletCharacter = _ref5.bulletCharacter,
      bulletColor = _ref5.bulletColor,
      bulletImage = _ref5.bulletImage,
      bulletColorInner = _ref5.bulletColorInner,
      bulletLeft = _ref5.bulletLeft,
      bulletSize = _ref5.bulletSize,
      bulletTop = _ref5.bulletTop,
      type = _ref5.type;

  switch (type) {
    case 'chevron':
      return "\n          &::before {\n            width: 0;\n            height: 0;\n            position: absolute;\n            top: ".concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            border-top: ").concat(bulletSize, "px solid transparent;\n            border-bottom: ").concat(bulletSize, "px solid transparent;\n            border-left: ").concat(bulletSize, "px solid ").concat(bulletColor, ";\n          }\n          &::after {\n            width: 0;\n            height: 0;\n            position: absolute;\n            top: ").concat(bulletTop + 4, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            border-top: ").concat(bulletSize - 4, "px solid transparent;\n            border-bottom: ").concat(bulletSize - 4, "px solid transparent;\n            border-left: ").concat(bulletSize - 4, "px solid ").concat(bulletColorInner, ";\n          }\n        ");

    case 'diamond':
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;\n            height: ").concat(bulletSize, "px;\n            background-color: ").concat(bulletColor, ";\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            display: block;\n            transform: rotate(45deg);\n          }\n        ");

    case 'diamondHollow':
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;\n            height: ").concat(bulletSize, "px;\n            background-color: ").concat(bulletColor, ";\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            transform: rotate(45deg);\n          }\n          &::after {\n            width: ").concat(bulletSize - 4, "px;\n            height: ").concat(bulletSize - 4, "px;\n            background-color: ").concat(bulletColorInner, ";\n            position: absolute;\n            top: ").concat(bulletTop + 2, "px;\n            left: ").concat(bulletLeft + 2, "px;\n            content: '';\n            transform: rotate(45deg);\n          }\n        ");

    case 'discHollow':
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;\n            height: ").concat(bulletSize, "px;\n            background-color: ").concat(bulletColor, ";\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            border-radius: 100%;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n          }\n          &::after {\n            width: ").concat(bulletSize - 4, "px;\n            height: ").concat(bulletSize - 4, "px;\n            background-color: ").concat(bulletColorInner, ";\n            position: absolute;\n            top: ").concat(bulletTop + 2, "px;\n            border-radius: 100%;\n            left: ").concat(bulletLeft + 2, "px;\n            content: '';\n          }\n        ");

    case 'image':
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;;\n            height: ").concat(bulletSize, "px;;\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            background-image: url(").concat(bulletImage, ");\n            background-size: 100% auto;\n            background-repeat: no-repeat;\n          }\n        ");

    case 'square':
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;\n            height: ").concat(bulletSize, "px;\n            background-color: ").concat(bulletColor, ";\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n          }\n        ");

    case 'squareHollow':
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;\n            height: ").concat(bulletSize, "px;\n            background-color: ").concat(bulletColor, ";\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n          }\n          &::after {\n            width: ").concat(bulletSize - 4, "px;\n            height: ").concat(bulletSize - 4, "px;\n            background-color: ").concat(bulletColorInner, ";\n            position: absolute;\n            top: ").concat(bulletTop + 2, "px;\n            left: ").concat(bulletLeft + 2, "px;\n            content: '';\n          }\n        ");

    case 'triangle':
      return "\n          &::before {\n            width: 0;\n            height: 0;\n            position: absolute;\n            top: ".concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            border-top: ").concat(bulletSize, "px solid transparent;\n            border-bottom: ").concat(bulletSize, "px solid transparent;\n            border-left: ").concat(bulletSize, "px solid ").concat(bulletColor, ";\n          }\n        ");

    case 'triangleHollow':
      return "\n          &::before {\n            width: 0;\n            height: 0;\n            position: absolute;\n            top: ".concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n            border-top: ").concat(bulletSize, "px solid transparent;\n            border-bottom: ").concat(bulletSize, "px solid transparent;\n            border-left: ").concat(bulletSize, "px solid ").concat(bulletColor, ";\n          }\n          &::after {\n            width: 0;\n            height: 0;\n            position: absolute;\n            top: ").concat(bulletTop + 4, "px;\n            left: ").concat(bulletLeft + 2, "px;\n            content: '';\n            border-top: ").concat(bulletSize - 4, "px solid transparent;\n            border-bottom: ").concat(bulletSize - 4, "px solid transparent;\n            border-left: ").concat(bulletSize - 4, "px solid ").concat(bulletColorInner, ";\n          }\n        ");

    case 'unicode':
      return "\n          &::before {\n            width: 0;\n            height: 0;\n            position: absolute;\n            top: ".concat(bulletTop, "px;\n            left: ").concat(bulletLeft, "px;\n            content: '").concat(bulletCharacter, "';\n            color: ").concat(bulletColor, ";\n          }\n        ");

    case 'disc':
    default:
      return "\n          &::before {\n            width: ".concat(bulletSize, "px;\n            height: ").concat(bulletSize, "px;\n            background-color: ").concat(bulletColor, ";\n            position: absolute;\n            top: ").concat(bulletTop, "px;\n            border-radius: 100%;\n            left: ").concat(bulletLeft, "px;\n            content: '';\n          }\n        ");
  }
});

var UnorderedList =
/*#__PURE__*/
function (_Component) {
  _inherits(UnorderedList, _Component);

  function UnorderedList() {
    _classCallCheck(this, UnorderedList);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnorderedList).apply(this, arguments));
  }

  _createClass(UnorderedList, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React__default.createElement(StyledUl, this.props, children);
    }
  }]);

  return UnorderedList;
}(React.Component);

_defineProperty(UnorderedList, "propTyps", {
  /** Unicode character to use for 'unicode' list type */
  bulletCharacter: PropTypes.string,

  /** Bullet color. */
  bulletColor: PropTypes.string,

  /** Bullet inner color - only for certain types. */
  bulletColorInner: PropTypes.string,

  /** Image for 'image' bullet type. */
  bulletImage: PropTypes.string,

  /** Bullet left positioning */
  bulletLeft: PropTypes.number,

  /** Bullet size for item elements, pixels. */
  bulletSize: PropTypes.number,

  /** Bullet top positioning. */
  bulletTop: PropTypes.number,

  /** Margin for child item elements. */
  itemMargin: PropTypes.string,

  /** Padding for child item elements. */
  itemPadding: PropTypes.string,

  /** List type for a 'standard' list (without custom bullet image). */
  type: PropTypes.string,

  /** Margin for list element. */
  margin: PropTypes.string,

  /** Padding for list element. */
  padding: PropTypes.string
});

_defineProperty(UnorderedList, "defaultProps", {
  bulletCharacter: "\u2713",
  bulletColor: '#000000',
  bulletColorInner: '#ffffff',
  bulletImage: '',
  bulletLeft: 0,
  bulletSize: 8,
  bulletTop: 5,
  itemMargin: 'initial',
  itemPadding: '0 0 0 30px',
  type: 'disc',
  margin: 'initial',
  padding: 'initial'
});

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  counter-reset: crane-list-counter;\n  list-style-type: none;\n  margin: ", ";\n  padding: ", ";\n  > li {\n    counter-increment: crane-list-counter;\n    margin: ", ";\n    padding: ", ";\n    position: relative;\n    &:before {\n      content: counter(crane-list-counter) '.';\n      position: absolute;\n      display: block;\n      width: ", "px;\n      height: ", "px;\n      font-size: ", "px;\n      font-weight: ", ";\n      font-family: ", ";\n      text-align: center;\n      line-height: ", "px;\n      color: ", ";\n      top: ", "px;\n      left: ", "px;\n    }\n  }\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

var StyledOl = styled.ol(_templateObject$l(), function (_ref) {
  var margin = _ref.margin;
  return margin || 'initial';
}, function (_ref2) {
  var padding = _ref2.padding;
  return padding || 'initial';
}, function (_ref3) {
  var itemMargin = _ref3.itemMargin;
  return itemMargin || 'initial';
}, function (_ref4) {
  var itemPadding = _ref4.itemPadding;
  return itemPadding || 'initial';
}, function (_ref5) {
  var bulletSize = _ref5.bulletSize;
  return bulletSize;
}, function (_ref6) {
  var bulletSize = _ref6.bulletSize;
  return bulletSize;
}, function (_ref7) {
  var bulletSize = _ref7.bulletSize;
  return bulletSize;
}, function (_ref8) {
  var bulletFontWeight = _ref8.bulletFontWeight;
  return bulletFontWeight;
}, function (_ref9) {
  var bulletFontFamily = _ref9.bulletFontFamily;
  return bulletFontFamily;
}, function (_ref10) {
  var bulletSize = _ref10.bulletSize;
  return bulletSize;
}, function (_ref11) {
  var bulletColor = _ref11.bulletColor;
  return bulletColor;
}, function (_ref12) {
  var bulletTop = _ref12.bulletTop;
  return bulletTop;
}, function (_ref13) {
  var bulletLeft = _ref13.bulletLeft;
  return bulletLeft;
});

var OrderedList =
/*#__PURE__*/
function (_Component) {
  _inherits(OrderedList, _Component);

  function OrderedList() {
    _classCallCheck(this, OrderedList);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrderedList).apply(this, arguments));
  }

  _createClass(OrderedList, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React__default.createElement(StyledOl, this.props, children);
    }
  }]);

  return OrderedList;
}(React.Component);

_defineProperty(OrderedList, "propTyps", {
  /** Bullet color. */
  bulletColor: PropTypes.string,

  /** Bullet font-family */
  bulletFontFamily: PropTypes.string,

  /** Bullet font weight */
  bulletFontWeight: PropTypes.string,

  /** Bullet left positioning */
  bulletLeft: PropTypes.number,

  /** Bullet size for item elements, pixels. */
  bulletSize: PropTypes.number,

  /** Bullet top positioning. */
  bulletTop: PropTypes.number,

  /** Margin for child item elements. */
  itemMargin: PropTypes.string,

  /** Padding for child item elements. */
  itemPadding: PropTypes.string,

  /** List type for a 'standard' list (without custom bullet image). */
  type: PropTypes.string,

  /** Margin for list element. */
  margin: PropTypes.string,

  /** Padding for list element. */
  padding: PropTypes.string
});

_defineProperty(OrderedList, "defaultProps", {
  bulletColor: '#000000',
  bulletFontFamily: 'inherit',
  bulletFontWeight: 'bold',
  bulletLeft: 0,
  bulletSize: 16,
  bulletTop: 3,
  itemMargin: 'initial',
  itemPadding: '0 0 0 30px',
  type: 'disc',
  margin: 'initial',
  padding: 'initial'
});

function _templateObject2$e() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  margin-top: 40px;\n  margin-right: 15px;\n  transform: translateY(-50%);\n  svg {\n    fill: ", ";\n  }\n  &:hover,\n  &:active {\n    opacity: 0.8;\n  }\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  float: right;\n  height: 100%;\n  > p {\n    font-size: 15px;\n    color: ", ";\n    margin: 0 10px 0 0;\n  }\n  @media screen and (max-width: 800px) {\n    display: none;\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var ShareContainer = styled.div(_templateObject$m(), function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
});
var ShareImage = styled.div(_templateObject2$e(), function (_ref2) {
  var color = _ref2.color;
  return color || '#000';
});

var ShareButtons = function ShareButtons(_ref3) {
  var color = _ref3.color,
      email = _ref3.email,
      facebook = _ref3.facebook,
      twitter = _ref3.twitter,
      whatsapp = _ref3.whatsapp,
      props = _objectWithoutProperties(_ref3, ["color", "email", "facebook", "twitter", "whatsapp"]);

  return React__default.createElement(ShareContainer, props, facebook && React__default.createElement("a", {
    href: facebook,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React__default.createElement(ShareImage, {
    color: color
  }, React__default.createElement(Icons.Facebook, null))), twitter && React__default.createElement("a", {
    href: twitter,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React__default.createElement(ShareImage, {
    color: color
  }, React__default.createElement(Icons.Twitter, null))), whatsapp && React__default.createElement("a", {
    href: whatsapp,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React__default.createElement(ShareImage, {
    color: color
  }, React__default.createElement(Icons.Whatsapp, null))), email && React__default.createElement("a", {
    href: email
  }, React__default.createElement(ShareImage, {
    color: color
  }, React__default.createElement(Icons.Email, null))));
};

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  box-shadow: ", ";\n  background-color: #fff;\n  overflow: hidden;\n  border-radius: ", ";\n  &.medium {\n    padding-top: 130%;\n  }\n  &.large {\n    padding-top: 36%;\n    @media screen and (max-width: 645px) {\n      padding-top: 130%;\n    }\n  }\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject$n(), function (_ref) {
  var shadow = _ref.shadow;
  return shadow ? '0 0 20px 0 rgba(0, 0, 0, 0.2)' : 'none';
}, function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return "".concat(borderRadius || 4, "px");
});

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  user-select: none;\n  position: relative;\n  padding: 0px 0 0 40px;\n  height: 40px;\n  font-size: 12px;\n  width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  font-size: 12px;\n  line-height: 12px;\n  user-select: none;\n  margin-top: 5px;\n  width: calc(100% - 30px);\n  padding-right: 10px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  font-size: 12px;\n  line-height: 12px;\n  user-select: none;\n  margin-top: 5px;\n  &:after {\n    text-shadow: none;\n    position: absolute;\n    top: 3px;\n    left: -35px;\n    content: '", "';\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    color: #fff;\n    font-size: 10px;\n    display: block;\n  }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  text-shadow: ", ";\n  display: block;\n  position: absolute;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  padding: 20px 0 0 20px;\n  top: 0;\n  transform: translateY(-100%);\n  transition: all 0.2s ease-in-out;\n  background-color: ", ";\n  box-shadow: ", ";\n  > div {\n    margin: 0;\n    user-select: none;\n    color: ", ";\n    width: 100%;\n    margin: 0;\n    font-size: 12px;\n  }\n  .topContentHidden {\n    transition: all 0.2s ease-in-out;\n    margin-top: -100%;\n    width: 100%;\n  }\n  .topContentVisible {\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    padding-top: 20px;\n    transition: all 0.2s ease-in-out;\n  }\n  svg {\n    width: 30px;\n    height: 30px;\n    margin: -5px 10px 0 0;\n    position: absolute;\n    left: 0;\n    filter: drop-shadow(0 0 10px #000);\n    transition: all 0.2s ease-in-out;\n    stroke: ", ";\n    stroke-width: 2;\n    fill: none;\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  padding: 10px 20px 10px 20px;\n  height: auto;\n  top: 100%;\n  transform: translateY(-72px);\n  transition: all 0.2s ease-in-out;\n  text-shadow: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  > .titleWrapper {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    overflow: hidden;\n    position: relative;\n    min-height: 52px;\n    > h2 {\n      user-select: none;\n      color: ", ";\n      transition: 0.1s all linear;\n      font-size: 20px;\n      line-height: 26px;\n      min-height: 0;\n      max-height: 52px;\n      margin: auto;\n      overflow: hidden;\n      padding: 0;\n      text-align: left;\n      width: 100%;\n      padding-right: 1rem;\n      position: relative;\n      &:before {\n        font-size: 20px;\n        content: '...';\n        position: absolute;\n        right: 0;\n        bottom: 0;\n        ", " font-weight: bold;\n        z-index: 5;\n      }\n      &:after {\n        content: '';\n        position: absolute;\n        right: 0;\n        width: 1rem;\n        height: 2rem;\n        margin-top: 0.3rem;\n        background: #ffffff;\n        z-index: 10;\n        ", " z-index: 10;\n      }\n    }\n  }\n  p {\n    user-select: none;\n    color: ", ";\n    width: 100%;\n    margin: 10px 0;\n    padding: 0;\n    font-size: 16px;\n    line-height: 22px;\n    &.labelText {\n      text-transform: uppercase;\n      font-size: 12px;\n      line-height: 12px;\n      padding: 0;\n    }\n  }\n  .large & {\n    @media screen and (min-width: 645px) {\n      transform: translateY(-80px);\n      > .titleWrapper {\n        min-height: 60px;\n        > h2 {\n          font-size: 30px;\n          line-height: 40px;\n          max-height: 40px;\n        }\n        > p {\n          font-size: 20px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  transition: all 0.2s ease-in-out;\n  margin-left: 0px;\n  top: 0;\n  left: 0;\n  &:after {\n    transition: all 0.2s ease-in-out;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    background-color: #000;\n    opacity: 0;\n  }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.2s all ease-in-out;\n  &.active,\n  &:active,\n  &:hover {\n    box-shadow: ", ";\n    .bottomContent {\n      transform: translateY(-99%);\n      > .titleWrapper {\n        height: auto;\n        overflow: auto;\n        > h2 {\n          max-height: 100%;\n          overflow: hidden;\n        }\n      }\n    }\n    .topContent {\n      transform: translateY(0%);\n      > .topContentHidden {\n        transition: all 0.2s ease-in-out;\n        margin-top: 0;\n      }\n      > .topContentVisible {\n        transition: all 0.2s ease-in-out;\n        padding-top: 0;\n      }\n    }\n    .cardImage {\n      &:after {\n        opacity: 0.3;\n      }\n    }\n  }\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: auto;\n  cursor: pointer;\n  border-radius: 4px;\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var OuterContainer = styled.div(_templateObject$o());
var StyledContainer = styled(Container)(_templateObject2$f(), function (_ref) {
  var shadow = _ref.shadow;
  return shadow ? '0 0 20px 0 rgba(0, 0, 0, 0.6)' : 'none';
});
var Image = styled.div(_templateObject3$8(), function (props) {
  return props.backgroundImage || '';
});
var BottomContent = styled.div(_templateObject4$3(), function (_ref2) {
  var bottomBackground = _ref2.bottomBackground;
  return bottomBackground ? 'none' : '0px 0px 5px rgba(0, 0, 0, 0.7);';
}, function (_ref3) {
  var bottomBackground = _ref3.bottomBackground;
  return bottomBackground ? '#ffffff' : 'transparent';
}, function (_ref4) {
  var bottomBackground = _ref4.bottomBackground;
  return bottomBackground ? '0 0 20px 0 rgba(0, 0, 0, 0.2)' : 'none';
}, function (_ref5) {
  var bottomBackground = _ref5.bottomBackground;
  return bottomBackground ? '#000000' : '#ffffff';
}, function (_ref6) {
  var bottomBackground = _ref6.bottomBackground;
  return bottomBackground ? '' : 'display: none;';
}, function (_ref7) {
  var bottomBackground = _ref7.bottomBackground;
  return bottomBackground ? 'display: block' : 'display: none;';
}, function (_ref8) {
  var bottomBackground = _ref8.bottomBackground;
  return bottomBackground ? '#000000' : '#ffffff';
});
var TopContent = styled.div(_templateObject5$3(), function (_ref9) {
  var topBackground = _ref9.topBackground;
  return topBackground ? 'none' : '0px 0px 5px rgba(0, 0, 0, 0.7);';
}, function (_ref10) {
  var topBackground = _ref10.topBackground;
  return topBackground ? '#ffffff' : 'transparent';
}, function (_ref11) {
  var topBackground = _ref11.topBackground;
  return topBackground ? '0 0 20px 0 rgba(0, 0, 0, 0.2)' : 'none';
}, function (_ref12) {
  var topBackground = _ref12.topBackground;
  return topBackground ? '#000000' : '#ffffff';
}, function (_ref13) {
  var topBackground = _ref13.topBackground;
  return topBackground ? '#000' : '#fff';
});
var DateSpan = styled.span(_templateObject6$1(), function (_ref14) {
  var day = _ref14.day;
  return day || 8;
});
var InfoSpan = styled.div(_templateObject7());
var Info = styled.div(_templateObject8());

var formatMinutes = function formatMinutes(m) {
  return m < 10 ? "0".concat(m) : m;
};

var ComplexCard =
/*#__PURE__*/
function (_Component) {
  _inherits(ComplexCard, _Component);

  function ComplexCard(props) {
    var _this;

    _classCallCheck(this, ComplexCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComplexCard).call(this, props));
    _this.state = {
      active: false
    };
    _this.toggleActive = _this.toggleActive.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ComplexCard, [{
    key: "toggleActive",
    value: function toggleActive(x) {
      this.setState({
        active: x
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var active = this.state.active;

      var _this$props = this.props,
          author = _this$props.author,
          borderRadius = _this$props.borderRadius,
          ctaText = _this$props.ctaText,
          image = _this$props.image,
          bottomBackground = _this$props.bottomBackground,
          topBackground = _this$props.topBackground,
          location = _this$props.location,
          title = _this$props.title,
          signatureCount = _this$props.signatureCount,
          signatureMax = _this$props.signatureMax,
          commentCount = _this$props.commentCount,
          publishDate = _this$props.publishDate,
          shadow = _this$props.shadow,
          startDate = _this$props.startDate,
          summary = _this$props.summary,
          size = _this$props.size,
          onClickHandler = _this$props.onClickHandler,
          props = _objectWithoutProperties(_this$props, ["author", "borderRadius", "ctaText", "image", "bottomBackground", "topBackground", "location", "title", "signatureCount", "signatureMax", "commentCount", "publishDate", "shadow", "startDate", "summary", "size", "onClickHandler"]);

      var start = new Date(startDate);
      var publish = new Date(publishDate);
      return React__default.createElement(OuterContainer, _extends({
        onMouseEnter: function onMouseEnter() {
          _this2.toggleActive(true);
        },
        onTouchStart: function onTouchStart() {
          _this2.toggleActive(true);
        },
        onTouchEnd: function onTouchEnd() {
          _this2.toggleActive(false);
        },
        onMouseLeave: function onMouseLeave() {
          _this2.toggleActive(false);
        },
        onClick: onClickHandler || function () {
          console.log('no card onClick hander');
        }
      }, props), React__default.createElement(StyledContainer, {
        className: "".concat(active ? 'active' : '', " ").concat(size || 'medium'),
        size: size,
        shadow: shadow,
        borderRadius: borderRadius || 4
      }, image ? React__default.createElement(Image, {
        className: "cardImage",
        backgroundImage: image
      }) : null, React__default.createElement(TopContent, {
        className: "topContent",
        topBackground: topBackground
      }, React__default.createElement("div", {
        className: "topContentHidden"
      }, author ? React__default.createElement(Info, null, React__default.createElement(User, {
        title: "author"
      }), React__default.createElement(InfoSpan, null, author)) : null, publishDate ? React__default.createElement(Info, null, React__default.createElement(Calendar, {
        title: "publish date"
      }), React__default.createElement(DateSpan, {
        day: publish.getDate()
      }, publish.getDate(), "-", publish.getMonth() + 1, "-", publish.getFullYear(), ' ')) : null, commentCount ? React__default.createElement(Info, null, React__default.createElement(Message, {
        title: "comments"
      }), React__default.createElement(InfoSpan, null, commentCount)) : null, location && location.name ? React__default.createElement(Info, null, React__default.createElement(Pin, {
        title: "location"
      }), React__default.createElement(InfoSpan, null, location.name ? "".concat(location.name, " ") : null)) : null), React__default.createElement("div", {
        className: "topContentVisible"
      }, signatureCount ? React__default.createElement(Info, null, React__default.createElement(Check, {
        title: "signatures"
      }), React__default.createElement(InfoSpan, null, React__default.createElement(Counter, {
        max: signatureMax || 1000,
        current: signatureCount,
        height: "8",
        barColor: "#fff",
        borderColor: "#fff"
      }))) : null, startDate ? React__default.createElement(Info, null, React__default.createElement(Calendar, {
        title: "Start date"
      }), React__default.createElement(DateSpan, {
        day: start.getDate()
      }, formatMinutes(start.getDate()), "-", formatMinutes(start.getMonth() + 1), "-", start.getFullYear(), " ", start.getUTCHours() + 1, ":", formatMinutes(start.getUTCMinutes()))) : null)), React__default.createElement(BottomContent, {
        className: "bottomContent",
        bottomBackground: bottomBackground
      }, React__default.createElement("div", {
        className: "titleWrapper"
      }, React__default.createElement("h2", null, title)), React__default.createElement("p", null, summary), ctaText ? React__default.createElement("p", {
        className: "labelText"
      }, ctaText) : null)));
    }
  }]);

  return ComplexCard;
}(React.Component);

_defineProperty(ComplexCard, "propTypes", {
  /** Author or authors of the node. */
  author: PropTypes.string,

  /** Border radius, pixels. Default = 4 */
  borderRadius: PropTypes.string,

  /** Toggles solid white/transparent background of the bottom content. */
  bottomBackground: PropTypes.bool,

  /** Number of comments. */
  commentCount: PropTypes.string,

  /** Call to action text. */
  ctaText: PropTypes.string,

  /** URI of the background image. */
  image: PropTypes.string,

  /** Location object { name[, street, city, zip, country] }. */
  location: PropTypes.object,

  /** onClick handler funtion. */
  onClickHandler: PropTypes.func,

  /** Article publish date. A string that can be converted into a JS Date object. */
  publishDate: PropTypes.string,

  /** Toggles background shadow for the card. */
  shadow: PropTypes.bool,

  /** Number of signatures. */
  signatureCount: PropTypes.number,

  /** Max number of signatures (or current target). Used for the counter. */
  signatureMax: PropTypes.number,

  /** Size of the cards. 'medium' or 'large'. */
  size: PropTypes.string,

  /** Event publish date. A string that can be converted into a JS Date object. */
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Summary text for the card. */
  summary: PropTypes.string.isRequired,

  /** Title text for the card. */
  title: PropTypes.string.isRequired,

  /** Toggles solid white/transparent background of the top content. */
  topBackground: PropTypes.bool
});

_defineProperty(ComplexCard, "defaultProps", {
  author: '',
  borderRadius: '4',
  bottomBackground: false,
  commentCount: '',
  ctaText: '',
  image: '',
  location: {},
  onClickHandler: function onClickHandler() {},
  publishDate: '',
  shadow: true,
  signatureCount: 0,
  signatureMax: 0,
  size: 'medium',
  startDate: '',
  topBackground: false
});

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  user-select: none;\n  position: relative;\n  padding: 0 0 0 0;\n  height: 40px;\n  font-size: 12px;\n  margin-right: 10px;\n  width: auto;\n  min-width: calc(50% - 10px);\n  color: #999;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  font-size: 12px;\n  line-height: 12px;\n  user-select: none;\n  margin-top: 5px;\n  width: calc(100% - 30px);\n  padding-right: 10px;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  margin-top: 20px;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  font-size: 12px;\n  line-height: 12px;\n  user-select: none;\n  margin-top: 5px;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n  background-color: ", ";\n  ", " > h2 {\n    user-select: none;\n    color: ", ";\n    transition: 0.1s all linear;\n    font-size: 20px;\n    line-height: 26px;\n    margin: 10px 0;\n    overflow: hidden;\n    padding: 0;\n    text-align: left;\n    width: 100%;\n    padding-right: 1rem;\n    position: relative;\n  }\n  p {\n    user-select: none;\n    color: ", ";\n    width: 100%;\n    margin: 10px 0;\n    padding: 0;\n    font-size: 16px;\n    line-height: 22px;\n    &.labelText {\n      text-transform: uppercase;\n      font-size: 12px;\n      line-height: 12px;\n      padding: 0;\n    }\n  }\n  .large & {\n    @media screen and (min-width: 645px) {\n      > h2 {\n        font-size: 30px;\n        line-height: 40px;\n        overflow: initial;\n      }\n      > p {\n        font-size: 20px;\n        line-height: 28px;\n      }\n    }\n  }\n  svg {\n    width: 30px;\n    height: 30px;\n    margin: -5px 10px 0 0;\n    position: absolute;\n    left: 0;\n    transition: all 0.2s ease-in-out;\n    stroke: #000;\n    stroke-width: 2;\n    fill: none;\n  }\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  padding-top: 56.25%;\n  height: auto;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  top: 0;\n  flex-basis: auto;\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  transition: 0.1s all linear;\n  .large & {\n    @media screen and (min-width: 645px) {\n      display: inline-block;\n      float: left;\n      width: 50%;\n      min-width: 50%;\n      max-width: 50%;\n    }\n  }\n  &:after {\n    transition: all 0.2s ease-in-out;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    background-color: #000;\n    opacity: 0;\n  }\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.2s all ease-in-out;\n  position: relative;\n  &.active,\n  &:active,\n  &:hover {\n    box-shadow: ", ";\n    .cardImage {\n      &:after {\n        opacity: 0.3;\n      }\n    }\n  }\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: auto;\n  cursor: pointer;\n  border-radius: 4px;\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var OuterContainer$1 = styled.div(_templateObject$p());
var InnerContainer = styled.div(_templateObject2$g());
var StyledContainer$1 = styled(Container)(_templateObject3$9(), function (_ref) {
  var shadow = _ref.shadow;
  return shadow ? '0 0 20px 0 rgba(0, 0, 0, 0.6)' : 'none';
});
var Image$1 = styled.div(_templateObject4$4(), function (props) {
  return props.backgroundImage || '';
});
var BottomContent$1 = styled.div(_templateObject5$4(), function (_ref2) {
  var bottomBackgroundColor = _ref2.bottomBackgroundColor;
  return bottomBackgroundColor;
}, function (_ref3) {
  var image = _ref3.image;
  return image ? ".large & {\n    @media screen and (min-width: 645px) {\n      display: inline-flex;\n      float: right;\n      width: 50%;\n      min-width: 50%;\n      max-width: 50%;\n      height: 100%;\n      flex-direction: column;\n      justify-content: center;\n      transition: all 0.2s ease-in-out;\n    }\n  }" : '';
}, function (_ref4) {
  var bottomTextColor = _ref4.bottomTextColor;
  return bottomTextColor;
}, function (_ref5) {
  var bottomTextColor = _ref5.bottomTextColor;
  return bottomTextColor;
});
var DateSpan$1 = styled.span(_templateObject6$2());
var InfoWrapper = styled.div(_templateObject7$1());
var InfoSpan$1 = styled.div(_templateObject8$1());
var Info$1 = styled.div(_templateObject9());

var formatMinutes$1 = function formatMinutes(m) {
  return m < 10 ? "0".concat(m) : m;
};

var SimpleCard =
/*#__PURE__*/
function (_Component) {
  _inherits(SimpleCard, _Component);

  function SimpleCard(props) {
    var _this;

    _classCallCheck(this, SimpleCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleCard).call(this, props));
    _this.state = {
      active: false
    };
    _this.toggleActive = _this.toggleActive.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SimpleCard, [{
    key: "toggleActive",
    value: function toggleActive(x) {
      this.setState({
        active: x
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var active = this.state.active;

      var _this$props = this.props,
          author = _this$props.author,
          borderRadius = _this$props.borderRadius,
          ctaText = _this$props.ctaText,
          image = _this$props.image,
          location = _this$props.location,
          title = _this$props.title,
          signatureCount = _this$props.signatureCount,
          signatureMax = _this$props.signatureMax,
          commentCount = _this$props.commentCount,
          publishDate = _this$props.publishDate,
          shadow = _this$props.shadow,
          startDate = _this$props.startDate,
          summary = _this$props.summary,
          size = _this$props.size,
          onClickHandler = _this$props.onClickHandler,
          bottomBackgroundColor = _this$props.bottomBackgroundColor,
          bottomTextColor = _this$props.bottomTextColor,
          props = _objectWithoutProperties(_this$props, ["author", "borderRadius", "ctaText", "image", "location", "title", "signatureCount", "signatureMax", "commentCount", "publishDate", "shadow", "startDate", "summary", "size", "onClickHandler", "bottomBackgroundColor", "bottomTextColor"]);

      var start = new Date(startDate);
      var publish = new Date(publishDate);
      return React__default.createElement(OuterContainer$1, _extends({
        onMouseEnter: function onMouseEnter() {
          _this2.toggleActive(true);
        },
        onTouchStart: function onTouchStart() {
          _this2.toggleActive(true);
        },
        onTouchEnd: function onTouchEnd() {
          _this2.toggleActive(false);
        },
        onMouseLeave: function onMouseLeave() {
          _this2.toggleActive(false);
        },
        onClick: onClickHandler || function () {
          console.log('no card onClick hander');
        }
      }, props), React__default.createElement(StyledContainer$1, {
        className: "".concat(active ? 'active' : '', " ").concat(size || 'medium'),
        size: size,
        shadow: shadow,
        borderRadius: borderRadius
      }, React__default.createElement(InnerContainer, null, image ? React__default.createElement(Image$1, {
        backgroundImage: image
      }) : null, React__default.createElement(BottomContent$1, {
        image: image,
        bottomBackgroundColor: bottomBackgroundColor,
        bottomTextColor: bottomTextColor
      }, React__default.createElement("h2", null, title), React__default.createElement("p", null, summary), React__default.createElement(InfoWrapper, null, ctaText ? React__default.createElement("p", {
        className: "labelText"
      }, ctaText) : null, author ? React__default.createElement(Info$1, null, React__default.createElement(InfoSpan$1, null, author)) : null, publishDate ? React__default.createElement(Info$1, null, React__default.createElement(DateSpan$1, {
        day: publish.getDate()
      }, publish.getDate(), "-", publish.getMonth() + 1, "-", publish.getFullYear(), ' ')) : null, commentCount ? React__default.createElement(Info$1, null, React__default.createElement(InfoSpan$1, null, commentCount, " comments")) : null, location && location.name ? React__default.createElement(Info$1, null, React__default.createElement(InfoSpan$1, null, location.name ? "".concat(location.name, " ") : null, location.street ? "".concat(location.street, " ") : null, location.city ? "".concat(location.city, " ") : null, location.zip ? "".concat(location.zip, " ") : null, location.country ? "".concat(location.country, " ") : null)) : null, signatureCount ? React__default.createElement(Info$1, null, React__default.createElement(InfoSpan$1, null, React__default.createElement(Counter, {
        max: signatureMax || 1000,
        current: signatureCount,
        height: "8"
      }))) : null, startDate ? React__default.createElement(Info$1, null, React__default.createElement(DateSpan$1, {
        day: start.getDate()
      }, start.getDate(), "-", start.getMonth() + 1, "-", start.getFullYear(), ' ', start.getUTCHours() + 1, ":", formatMinutes$1(start.getUTCMinutes()))) : null)))));
    }
  }]);

  return SimpleCard;
}(React.Component);

_defineProperty(SimpleCard, "propTypes", {
  /** Author or authors of the node. */
  author: PropTypes.string,

  /** Border radius, pixels. Default = 4 */
  borderRadius: PropTypes.string,

  /** Toggles solid white/transparent background of the bottom content. */
  bottomTextColor: PropTypes.string,

  /** Bottom section text color */
  bottomBackgroundColor: PropTypes.string,

  /** Bottom section background color */
  commentCount: PropTypes.string,

  /** Call to action text. */
  ctaText: PropTypes.string,

  /** URI of the background image. */
  image: PropTypes.string,

  /** Location object { name[, street, city, zip, country] }. */
  location: PropTypes.object,

  /** onClick handler funtion. */
  onClickHandler: PropTypes.func,

  /** Article publish date. A string that can be converted into a JS Date object. */
  publishDate: PropTypes.string,

  /** Toggles background shadow for the card. */
  shadow: PropTypes.bool,

  /** Number of signatures. */
  signatureCount: PropTypes.number,

  /** Max number of signatures (or current target). Used for the counter. */
  signatureMax: PropTypes.number,

  /** Size of the cards. 'medium' or 'large'. */
  size: PropTypes.string,

  /** Event publish date. A string that can be converted into a JS Date object. */
  startDate: PropTypes.string,

  /** Summary text for the card. */
  summary: PropTypes.string.isRequired,

  /** Title text for the card. */
  title: PropTypes.string.isRequired
});

_defineProperty(SimpleCard, "defaultProps", {
  author: '',
  borderRadius: '4',
  bottomBackgroundColor: '#fff',
  bottomTextColor: '#000',
  commentCount: '',
  ctaText: '',
  image: '',
  location: {},
  onClickHandler: function onClickHandler() {},
  publishDate: '',
  shadow: true,
  signatureCount: 0,
  signatureMax: 0,
  size: 'medium',
  startDate: ''
});

function _templateObject3$a() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.2s all ease-in-out;\n  position: relative;\n  &.active,\n  &:active,\n  &:hover {\n    box-shadow: ", ";\n    .cardImage {\n      &:after {\n        opacity: 0.3;\n      }\n    }\n  }\n  &.medium {\n    padding-top: ", ";\n  }\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: auto;\n  cursor: pointer;\n  border-radius: 4px;\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

var OuterContainer$2 = styled.div(_templateObject$q());
var StyledContainer$2 = styled(Container)(_templateObject2$h(), function (_ref) {
  var shadow = _ref.shadow;
  return shadow ? '0 0 20px 0 rgba(0, 0, 0, 0.6)' : 'none';
}, function (_ref2) {
  var maintainRatio = _ref2.maintainRatio;
  return maintainRatio ? '130%' : '0';
});
var Content = styled.div(_templateObject3$a());

var EmptyCard =
/*#__PURE__*/
function (_Component) {
  _inherits(EmptyCard, _Component);

  function EmptyCard() {
    _classCallCheck(this, EmptyCard);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmptyCard).apply(this, arguments));
  }

  _createClass(EmptyCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          borderRadius = _this$props.borderRadius,
          maintainRatio = _this$props.maintainRatio,
          shadow = _this$props.shadow,
          size = _this$props.size,
          children = _this$props.children;
      return React__default.createElement(OuterContainer$2, this.props, React__default.createElement(StyledContainer$2, {
        className: "".concat(size || 'medium'),
        size: size,
        shadow: shadow,
        maintainRatio: maintainRatio,
        borderRadius: borderRadius
      }, React__default.createElement(Content, null, children)));
    }
  }]);

  return EmptyCard;
}(React.Component);

_defineProperty(EmptyCard, "propTypes", {
  /** Border radius, pixels. Default = 4 */
  borderRadius: PropTypes.number,

  /** Maintain aspect ratio or have variable height */
  maintainRatio: PropTypes.bool,

  /** Toggles box-shadow */
  shadow: PropTypes.bool,

  /** Size of card. Medium/Large */
  size: PropTypes.string
});

_defineProperty(EmptyCard, "defaultProps", {
  borderRadius: '4',
  maintainRatio: true,
  shadow: true,
  size: 'medium'
});

function _templateObject3$b() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.8);\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  opacity: 0;\n  transition: opacity 0.4s ease-in-out;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  color: #ffffff;\n  left: -999999999px;\n  z-index: 999999;\n  cursor: pointer;\n  > img {\n    max-width: calc(100% - 40px);\n    max-height: calc(100% - 40px);\n    margin: 0;\n    position: relative;\n  }\n  > p {\n    margin-top: 10px;\n    padding: 0;\n    position: relative;\n  }\n  &.show {\n    opacity: 1;\n    transition: opacity 0.4s ease-in-out;\n    left: 0;\n  }\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: block;\n  margin: 0;\n  padding: 0;\n  &.hasLightbox {\n    cursor: pointer;\n  }\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n  width: ", "%;\n  height: 100%;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

var ImageContainer = styled.div(_templateObject$r(), function (_ref) {
  var itemCount = _ref.itemCount;
  return itemCount ? 100 / itemCount : '100';
});
var Image$2 = styled.img(_templateObject2$i());
var Lightbox = styled.div(_templateObject3$b());

var GalleryImage =
/*#__PURE__*/
function (_Component) {
  _inherits(GalleryImage, _Component);

  function GalleryImage(props) {
    var _this;

    _classCallCheck(this, GalleryImage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GalleryImage).call(this, props));
    _this.state = {
      showLightbox: false
    };
    _this.toggleLightbox = _this.toggleLightbox.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(GalleryImage, [{
    key: "toggleLightbox",
    value: function toggleLightbox() {
      this.setState({
        showLightbox: !this.state.showLightbox
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          item = _this$props.item,
          itemCount = _this$props.itemCount,
          lightbox = _this$props.lightbox;
      var showLightbox = this.state.showLightbox;
      return React__default.createElement(ImageContainer, {
        itemCount: itemCount
      }, lightbox ? React__default.createElement(Lightbox, {
        onClick: function onClick() {
          return _this2.toggleLightbox();
        },
        className: showLightbox ? 'show' : ''
      }, React__default.createElement("img", {
        src: item.url,
        alt: ""
      }), React__default.createElement("p", null, item.description)) : null, React__default.createElement(Image$2, {
        itemCount: itemCount,
        src: item.url,
        className: lightbox ? 'hasLightbox' : '',
        onClick: function onClick() {
          return _this2.toggleLightbox();
        }
      }));
    }
  }]);

  return GalleryImage;
}(React.Component);

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  position: relative;\n  display: inline-block;\n  background-color: ", ";\n  border-radius: 100%;\n  margin: 0 5px;\n  transition: 0.1s all linear;\n  &:hover {\n    background-color: rgba(255, 255, 255, 1);\n    cursor: pointer;\n  }\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 10px;\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

var DotsContainer = styled.div(_templateObject$s());
var Dot = styled.div(_templateObject2$j(), function (_ref) {
  var current = _ref.current;
  return current ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.7)';
});

var Dots = function Dots(_ref2) {
  var currentItem = _ref2.currentItem,
      items = _ref2.items,
      callback = _ref2.callback;
  return React__default.createElement(DotsContainer, null, items.map(function (item, idx) {
    return React__default.createElement(Dot, {
      current: idx === currentItem,
      onClick: function onClick() {
        return callback(idx, items, item);
      }
    });
  }));
};

function _templateObject2$k() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  width: ", "%;\n  height: 100%;\n  transition: 0.3s all linear;\n  margin-left: -", "%;\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  &.fullwidth {\n    width: 100vw;\n    margin-left: 50%;\n    transform: translateX(-50vw);\n  }\n  .left,\n  .right {\n    position: absolute;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    stroke: #fff;\n    stroke-linecap: butt;\n    stroke-width: 2;\n    fill: none;\n  }\n  .left {\n    left: 10px;\n  }\n  .right {\n    right: 10px;\n  }\n  .play,\n  .pause {\n    position: absolute;\n    left: 10px;\n    bottom: 20px;\n    margin-bottom: 0;\n    width: 24px;\n    height: 24px;\n    stroke: #fff;\n    stroke-width: 2;\n    fill: none;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var ContainerOuter = styled.div(_templateObject$t());
var ContainerInner = styled.div(_templateObject2$k(), function (_ref) {
  var itemCount = _ref.itemCount;
  return itemCount ? itemCount * 100 : '100';
}, function (_ref2) {
  var currentItem = _ref2.currentItem;
  return currentItem > 0 ? currentItem * 100 : 0;
});

var Gallery =
/*#__PURE__*/
function (_Component) {
  _inherits(Gallery, _Component);

  function Gallery(props) {
    var _this;

    _classCallCheck(this, Gallery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Gallery).call(this, props));
    _this.state = {
      itemCount: _this.props.items.length,
      currentItem: 0,
      autoplay: _this.props.autoplay || false,
      playing: _this.props.autoplay || false
    };
    _this.interval = null;
    _this.setItem = _this.setItem.bind(_assertThisInitialized(_this));
    _this.nextItem = _this.nextItem.bind(_assertThisInitialized(_this));
    _this.prevItem = _this.prevItem.bind(_assertThisInitialized(_this));
    _this.play = _this.play.bind(_assertThisInitialized(_this));
    _this.pause = _this.pause.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Gallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoplay = this.state.autoplay;

      if (autoplay) {
        this.play();
      }
    } // Updates the current item

  }, {
    key: "setItem",
    value: function setItem(item) {
      this.setState({
        currentItem: item
      });
    } // Updates the current item to the next item, or if the first item if at end of array.

  }, {
    key: "nextItem",
    value: function nextItem() {
      var _this$state = this.state,
          itemCount = _this$state.itemCount,
          currentItem = _this$state.currentItem;

      if (currentItem + 1 === itemCount) {
        return this.setItem(0);
      }

      return this.setItem(currentItem + 1);
    } // Updates the current item to the previous item, or if the last item if at beginning of array.

  }, {
    key: "prevItem",
    value: function prevItem() {
      var _this$state2 = this.state,
          itemCount = _this$state2.itemCount,
          currentItem = _this$state2.currentItem;

      if (currentItem - 1 < 0) {
        return this.setItem(itemCount - 1);
      }

      return this.setItem(currentItem - 1);
    } // Starts playing of content, sets interval

  }, {
    key: "play",
    value: function play() {
      var _this2 = this;

      var delay = this.props.delay || 6000;
      var interval = setInterval(function () {
        _this2.nextItem();
      }, delay);
      this.interval = interval;
      this.setState({
        playing: true
      });
    } // Stops playing of content, clears interval

  }, {
    key: "pause",
    value: function pause() {
      clearInterval(this.interval);
      this.setState({
        playing: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          fullWidth = _this$props.fullWidth,
          showControls = _this$props.showControls,
          items = _this$props.items,
          lightbox = _this$props.lightbox,
          showDots = _this$props.showDots;
      var _this$state3 = this.state,
          playing = _this$state3.playing,
          itemCount = _this$state3.itemCount,
          currentItem = _this$state3.currentItem;
      var PlayPause = playing ? React__default.createElement(Pause, {
        className: "pause",
        title: "Pause",
        onClick: function onClick() {
          return _this3.pause();
        }
      }) : React__default.createElement(Play, {
        className: "play",
        title: "Play",
        onClick: function onClick() {
          return _this3.play();
        }
      });
      return React__default.createElement(ContainerOuter, {
        className: fullWidth ? 'fullwidth' : ''
      }, React__default.createElement(ContainerInner, {
        itemCount: itemCount,
        currentItem: currentItem
      }, items.map(function (item) {
        return React__default.createElement(GalleryImage, {
          key: randomString(),
          itemCount: itemCount,
          item: item,
          lightbox: lightbox
        });
      })), showDots ? React__default.createElement(Dots, {
        items: items,
        currentItem: currentItem,
        callback: this.setItem
      }) : null, showControls ? PlayPause : null, React__default.createElement(ChevronLeft, {
        className: "left",
        title: "previous image",
        onClick: function onClick() {
          return _this3.prevItem();
        }
      }), React__default.createElement(ChevronRight, {
        className: "right",
        title: "next image",
        onClick: function onClick() {
          return _this3.prevItem();
        }
      }));
    }
  }]);

  return Gallery;
}(React.Component);

_defineProperty(Gallery, "propTypes", {
  /** Determines whether the gallery should autoplay when the component mounts */
  autoplay: PropTypes.bool,

  /** The transition delay time between images when playing (miliseconds) */
  delay: PropTypes.number,

  /** Determines whether the gallery should stratch to the full width of the window or stay within its container */
  fullWidth: PropTypes.bool,

  /** Determines whether a lightbox should be shown when clicking on an image */
  lightbox: PropTypes.bool,

  /** Toggles the gallery controls (pause/play/etc) */
  showControls: PropTypes.bool,

  /** Toggles the dots that can be used to navigate between images */
  showDots: PropTypes.bool
});

_defineProperty(Gallery, "defaultProps", {
  autoplay: true,
  delay: 6000,
  fullWidth: false,
  lightbox: true,
  showControls: false,
  showDots: false
});

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  width: 100%;\n  height: auto;\n  & > * {\n    width: ", ";\n    max-width: ", ";\n    min-width: ", ";\n    flex: 0 0 ", ";\n    margin: ", ";\n    height: auto;\n    @media screen and (max-width: 900px) {\n      width: ", ";\n      max-width: ", ";\n      min-width: ", ";\n      flex: 0 0 ", ";\n    }\n    @media screen and (max-width: 645px) {\n      width: ", ";\n      max-width: ", ";\n      min-width: ", ";\n      flex: 0 0 ", ";\n    }\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var calculatePercentage = function calculatePercentage(n) {
  return 100 / n;
};

var getDivisions = function getDivisions(n) {
  return n || 4;
};

var getMargins = function getMargins(n) {
  return (n || 0) * 2;
}; // Return css calc() for witdh of item.


var returnCalc = function returnCalc(screen, props) {
  var divisions = props.divisions,
      tabletDivisions = props.tabletDivisions,
      mobileDivisions = props.mobileDivisions,
      margins = props.margins;

  switch (screen) {
    case 'mobile':
      return "calc(".concat(calculatePercentage(getDivisions(mobileDivisions || 1)), "% - ").concat(getMargins(margins), "px)");

    case 'tablet':
      return "calc(".concat(calculatePercentage(getDivisions(tabletDivisions || 2)), "% - ").concat(getMargins(margins), "px)");

    case 'desktop':
    default:
      return "calc(".concat(calculatePercentage(getDivisions(divisions)), "% - ").concat(getMargins(margins), "px)");
  }
};

var FlexGrid = styled.div(_templateObject$u(), function (props) {
  return props.flexDirection || 'row';
}, function (props) {
  return props.flexWrap || 'wrap';
}, function (props) {
  return props.alignItems || 'flex-start';
}, function (props) {
  return props.justifyContent || 'center';
}, function (props) {
  return returnCalc('desktop', props);
}, function (props) {
  return returnCalc('desktop', props);
}, function (props) {
  return returnCalc('desktop', props);
}, function (props) {
  return returnCalc('desktop', props);
}, function (props) {
  return "".concat(props.margins, "px");
}, function (props) {
  return returnCalc('tablet', props);
}, function (props) {
  return returnCalc('tablet', props);
}, function (props) {
  return returnCalc('tablet', props);
}, function (props) {
  return returnCalc('tablet', props);
}, function (props) {
  return returnCalc('mobile', props);
}, function (props) {
  return returnCalc('mobile', props);
}, function (props) {
  return returnCalc('mobile', props);
}, function (props) {
  return returnCalc('mobile', props);
});

var SignupForm =
/*#__PURE__*/
function (_Component) {
  _inherits(SignupForm, _Component);

  function SignupForm() {
    _classCallCheck(this, SignupForm);

    return _possibleConstructorReturn(this, _getPrototypeOf(SignupForm).apply(this, arguments));
  }

  _createClass(SignupForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          emailFieldLabel = _this$props.emailFieldLabel,
          emailFieldName = _this$props.emailFieldName,
          buttonLabel = _this$props.buttonLabel,
          buttonName = _this$props.buttonName,
          linkedPrivacyMessage = _this$props.linkedPrivacyMessage,
          placeholderText = _this$props.placeholderText,
          privacyCheckbox = _this$props.privacyCheckbox,
          actionNetworkHelper = _this$props.actionNetworkHelper,
          children = _this$props.children,
          disabled = _this$props.disabled,
          props = _objectWithoutProperties(_this$props, ["emailFieldLabel", "emailFieldName", "buttonLabel", "buttonName", "linkedPrivacyMessage", "placeholderText", "privacyCheckbox", "actionNetworkHelper", "children", "disabled"]);

      return React__default.createElement("form", props, React__default.createElement(TextInput$2, {
        name: emailFieldName,
        labelText: emailFieldLabel,
        placeholder: placeholderText,
        disabled: disabled,
        type: "email",
        required: true
      }), actionNetworkHelper ? null : privacyCheckbox ? React__default.createElement(TextInput, {
        name: "privacy",
        labelText: linkedPrivacyMessage,
        required: true
      }) : React__default.createElement("small", null, linkedPrivacyMessage), React__default.createElement("button", {
        disabled: disabled,
        type: "submit",
        name: buttonName
      }, buttonLabel), children);
    }
  }]);

  return SignupForm;
}(React.Component);

_defineProperty(SignupForm, "propTypes", {
  /** Label for Email address field */
  emailFieldLabel: PropTypes.string,

  /** Email field `name` HTML attribute */
  emailFieldName: PropTypes.string,

  /** Label for Submit Button */
  buttonLabel: PropTypes.string,

  /** Button `name` HTML attribute */
  buttonName: PropTypes.string
});

_defineProperty(SignupForm, "defaultProps", {
  emailFieldLabel: 'Email address',
  emailFieldName: 'email',
  buttonLabel: 'Sign me up!',
  buttonName: 'submit'
});

function _templateObject2$l() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    width: 1em;\n    height: 1em;\n    stroke: #000;\n    stroke-width: 2;\n    fill: none;\n    vertical-align: baseline;\n    margin-right: 0.25em;\n    position: relative;\n    top: 0.125em;\n  }\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  font-size: 15px;\n  color: #b33a3a;\n  border: 2px solid #b33a3a;\n  border-radius: 4px;\n  padding: 5px 10px;\n  background-color: #f9ecec;\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

var Warning = styled.p(_templateObject$v());
var Title$4 = styled.h2(_templateObject2$l());

var Signup =
/*#__PURE__*/
function (_Component) {
  _inherits(Signup, _Component);

  function Signup(props) {
    var _this;

    _classCallCheck(this, Signup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Signup).call(this, props));
    _this.state = {
      showConfirmation: false,
      showError: false
    };
    _this.onSubmitHandler = _this.onSubmitHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Signup, [{
    key: "onSubmitHandler",
    value: function onSubmitHandler(e) {
      var _this2 = this;

      if (this.props.actionNetworkHelper) {
        e.preventDefault();
        fetch(this.props.actionNetworkHelper, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            person: {
              family_name: '',
              given_name: '',
              email_addresses: [{
                primary: true,
                address: e.target.elements.email.value,
                status: 'subscribed'
              }],
              postal_addesses: [{
                primary: true,
                country: 'NL'
              }]
            },
            triggers: {
              autoresponse: {
                enabled: true
              }
            },
            'action_network:referrer_data': {
              source: "Wings Site: ".concat(this.props.siteTitle),
              website: document.location.href
            }
          })
        }).then(function (res) {
          return res;
        }).then(function (res) {
          if (res.status === 200) {
            _this2.setState({
              showConfirmation: true
            });
          } else {
            _this2.setState({
              showError: true
            });
          }
        })["catch"](function (err) {
          console.log(err);

          _this2.setState({
            showError: true
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          showConfirmation = _this$state.showConfirmation,
          showError = _this$state.showError;

      var _this$props = this.props,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? randomString() : _this$props$target,
          title = _this$props.title,
          intro = _this$props.intro,
          icon = _this$props.icon,
          privacyMessage = _this$props.privacyMessage,
          privacyMessageLink = _this$props.privacyMessageLink,
          privacyCheckbox = _this$props.privacyCheckbox,
          confirmedText = _this$props.confirmedText,
          actionNetworkHelper = _this$props.actionNetworkHelper,
          className = _this$props.className,
          confirmationText = _this$props.confirmationText,
          confirmationTitle = _this$props.confirmationTitle,
          props = _objectWithoutProperties(_this$props, ["target", "title", "intro", "icon", "privacyMessage", "privacyMessageLink", "privacyCheckbox", "confirmedText", "actionNetworkHelper", "className", "confirmationText", "confirmationTitle"]);

      var linkedPrivacyMessage = insertLink(privacyMessage, privacyMessageLink);
      return React__default.createElement("section", {
        className: className
      }, showConfirmation && actionNetworkHelper ? React__default.createElement(Confirmation, {
        confirmationText: confirmationText,
        confirmationTitle: confirmationTitle
      }) : null, React__default.createElement(Title$4, null, !icon || React__default.createElement(Envelope, null), title), showConfirmation && !actionNetworkHelper ? React__default.createElement("p", null, confirmedText) : null, actionNetworkHelper || !showConfirmation ? React__default.createElement("div", null, React__default.createElement("p", {
        style: {
          marginTop: '0'
        }
      }, intro), React__default.createElement(SignupForm, _extends({
        disabled: showConfirmation
      }, {
        privacyCheckbox: privacyCheckbox,
        linkedPrivacyMessage: linkedPrivacyMessage
      }, props, {
        actionNetworkHelper: actionNetworkHelper,
        target: target,
        onSubmit: this.onSubmitHandler
      }))) : null, showError ? React__default.createElement(Warning, null, "Maak a.u.b. een nieuwsbrief keuze") : null, React__default.createElement("iframe", {
        id: target,
        name: target,
        title: target,
        style: {
          display: 'none'
        }
      }));
    }
  }]);

  return Signup;
}(React.Component);

_defineProperty(Signup, "propTypes", {
  /** Title */
  title: PropTypes.string,

  /** Introduction text */
  intro: PropTypes.string,

  /** Background image */
  icon: PropTypes.bool,

  /** Privacy message */
  privacyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** link to privacy policy */
  privacyMessageLink: PropTypes.string,

  /** is Privacy message a checkbox */
  privacyCheckbox: PropTypes.bool,

  /** Confirmation text */
  confirmedText: PropTypes.string
});

_defineProperty(Signup, "defaultProps", {
  title: '',
  intro: '',
  icon: false,
  privacyMessage: {
    start: 'I consent to the ',
    link: 'privacy policy',
    end: ' of Crane!'
  },
  privacyMessageLink: 'https://example.com',
  privacyCheckbox: true,
  confirmedText: 'Thank you for signing up. Please check your e-mail for confirmation.'
});

var SignupForm$1 =
/*#__PURE__*/
function (_Component) {
  _inherits(SignupForm, _Component);

  function SignupForm() {
    _classCallCheck(this, SignupForm);

    return _possibleConstructorReturn(this, _getPrototypeOf(SignupForm).apply(this, arguments));
  }

  _createClass(SignupForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          firstNameFieldLabel = _this$props.firstNameFieldLabel,
          firstNameFieldName = _this$props.firstNameFieldName,
          lastNameFieldLabel = _this$props.lastNameFieldLabel,
          lastNameFieldName = _this$props.lastNameFieldName,
          emailFieldLabel = _this$props.emailFieldLabel,
          emailFieldName = _this$props.emailFieldName,
          newsletterCheckboxTitle = _this$props.newsletterCheckboxTitle,
          newsletterCheckboxLabel = _this$props.newsletterCheckboxLabel,
          privacyCheckboxTitle = _this$props.privacyCheckboxTitle,
          privacyCheckboxLabel = _this$props.privacyCheckboxLabel,
          privacyCheckboxLink = _this$props.privacyCheckboxLink,
          buttonLabel = _this$props.buttonLabel,
          buttonName = _this$props.buttonName,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["firstNameFieldLabel", "firstNameFieldName", "lastNameFieldLabel", "lastNameFieldName", "emailFieldLabel", "emailFieldName", "newsletterCheckboxTitle", "newsletterCheckboxLabel", "privacyCheckboxTitle", "privacyCheckboxLabel", "privacyCheckboxLink", "buttonLabel", "buttonName", "children"]);

      var linkedPrivacyLabel = insertLink(privacyCheckboxLabel, privacyCheckboxLink);
      return React__default.createElement("form", props, React__default.createElement(TextInput$2, {
        name: firstNameFieldName,
        labelText: firstNameFieldLabel,
        type: "text",
        required: true
      }), React__default.createElement(TextInput$2, {
        name: lastNameFieldName,
        labelText: lastNameFieldLabel,
        type: "text",
        required: true
      }), React__default.createElement(TextInput$2, {
        name: emailFieldName,
        labelText: emailFieldLabel,
        type: "email",
        required: true
      }), React__default.createElement(TextInput, {
        name: "newsletter",
        titleText: newsletterCheckboxTitle,
        labelText: newsletterCheckboxLabel
      }), React__default.createElement(TextInput, {
        name: "privacy",
        titleText: privacyCheckboxTitle,
        labelText: linkedPrivacyLabel,
        required: true
      }), React__default.createElement("button", {
        type: "submit",
        name: buttonName
      }, buttonLabel), children);
    }
  }]);

  return SignupForm;
}(React.Component);

_defineProperty(SignupForm$1, "propTypes", {
  /** Label for First Name field */
  firstNameFieldLabel: PropTypes.string,

  /** First Name field `name` HTML attribute */
  firstNameFieldName: PropTypes.string,

  /** Label for Last Name field */
  lastNameFieldLabel: PropTypes.string,

  /** Last Name field `name` HTML attribute */
  lastNameFieldName: PropTypes.string,

  /** Label for Email address field */
  emailFieldLabel: PropTypes.string,

  /** Email field `name` HTML attribute */
  emailFieldName: PropTypes.string,

  /** Title for Newsletter Checkbox */
  newsletterCheckboxTitle: PropTypes.string,

  /** Label for Newsletter Checkbox */
  newsletterCheckboxLabel: PropTypes.string,

  /** Title for Privacy Checkbox */
  privacyCheckboxTitle: PropTypes.string,

  /** Label for Privacy Checkbox */
  privacyCheckboxLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** Link for Privacy Checkbox */
  privacyCheckboxLink: PropTypes.string,

  /** Label for Submit Button */
  buttonLabel: PropTypes.string,

  /** Button `name` HTML attribute */
  buttonName: PropTypes.string
});

_defineProperty(SignupForm$1, "defaultProps", {
  firstNameFieldLabel: 'First Name',
  firstNameFieldName: 'firstname',
  lastNameFieldLabel: 'Last Name',
  lastNameFieldName: 'lastname',
  emailFieldLabel: 'Email address',
  emailFieldName: 'email',
  buttonLabel: 'Sign me up!',
  buttonName: 'submit',
  newsletterCheckboxTitle: 'Stay up to date!',
  newsletterCheckboxLabel: 'Please send me mails about the Crane campaign. You may use my personal data for this.',
  privacyCheckboxTitle: '',
  privacyCheckboxLabel: {
    start: 'I consent to the ',
    link: 'privacy policy',
    end: ' of Crane'
  },
  privacyCheckboxLink: 'https://example.com'
});

var Signup$1 =
/*#__PURE__*/
function (_Component) {
  _inherits(Signup, _Component);

  function Signup() {
    _classCallCheck(this, Signup);

    return _possibleConstructorReturn(this, _getPrototypeOf(Signup).apply(this, arguments));
  }

  _createClass(Signup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          intro = _this$props.intro,
          image = _this$props.image,
          props = _objectWithoutProperties(_this$props, ["title", "intro", "image"]);

      return React__default.createElement("section", {
        style: image === '' ? {} : {
          backgroundImage: "url(".concat(image, ")")
        }
      }, React__default.createElement("h1", null, title), React__default.createElement("p", null, intro), React__default.createElement(SignupForm$1, props));
    }
  }]);

  return Signup;
}(React.Component);

_defineProperty(Signup$1, "propTypes", {
  /** Title */
  title: PropTypes.string,

  /** Introduction text */
  intro: PropTypes.string,

  /** Background image */
  image: PropTypes.string
});

_defineProperty(Signup$1, "defaultProps", {
  title: '',
  intro: '',
  image: ''
});

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n  width: 100vw;\n  margin-left: calc(50% - 50vw);\n  &:after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}

var wide = css(_templateObject$w());

function _templateObject2$m() {
  var data = _taggedTemplateLiteral(["\n  float: right;\n  margin: 0.5rem -10px;\n  width: calc(100% + 20px);\n  @media screen and (min-width: 420px) {\n    margin-left: 1.5rem;\n    width: 40%;\n  }\n  @media screen and (min-width: 1080px) {\n    margin-left: 2rem;\n    margin-right: -8rem;\n    width: 50%;\n  }\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  margin: 0.5rem -10px;\n  width: calc(100% + 20px);\n  @media screen and (min-width: 420px) {\n    margin-right: 1.5rem;\n    width: 40%;\n  }\n  @media screen and (min-width: 1080px) {\n    margin-right: 2rem;\n    margin-left: -8rem;\n    width: 50%;\n  }\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}

var ALIGNLEFT = css(_templateObject$x());
var ALIGNRIGHT = css(_templateObject2$m());

var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};

exports.ALIGNLEFT = ALIGNLEFT;
exports.ALIGNRIGHT = ALIGNRIGHT;
exports.Breakout = Breakout;
exports.Burger = Burger;
exports.Button = _Button;
exports.ComplexCard = ComplexCard;
exports.ConfirmationBox = Confirmation;
exports.Counter = Counter;
exports.FlexGrid = FlexGrid;
exports.Gallery = Gallery;
exports.Icons = Icons;
exports.LanguagePicker = LanguagePicker;
exports.Loading = Loading;
exports.MenuContentWrapper = ContentWrapper;
exports.MenuItem = MenuItem;
exports.Newsletter = Signup;
exports.NewsletterForm = SignupForm;
exports.PaginationControls = PaginationControls;
exports.RadioInput = RadioInput;
exports.ShareButtons = ShareButtons;
exports.Signup = Signup$1;
exports.SignupForm = SignupForm$1;
exports.SimpleCard = SimpleCard;
exports.SlideMenu = SlideMenu;
exports.createSvgIcon = createSvgIcon;
exports.getContrastColor = getContrastColor;
exports.separateUnit = separateUnit;
exports.toggleSlideMenu = toggleSlideMenu;
exports.useTheme = useTheme;
exports.wide = wide;